<template>
  <div class="productAbout">
    <div v-if="!isCustomized" class="details" v-show="enableButton">
      <div class="productDetails">
        <div class="productNameMobile">
          <h1 class="productNameMobile__title">
            {{ produto.NameComplete }}
          </h1>
        </div>
        <div class="productImages">
          <slick ref="slick" :options="slickOptions">
            <div
              class="productImages__images"
              v-for="(tes, ind) in imagensProduto"
              :key="ind"
            >
              <inner-image-zoom
                :src="tes.ImageUrl"
                :alt="produto.NameComplete"
              />
              <div class="productImages__quantityImages">
                {{ ind + 1 }} de {{ imagensProduto.length }}
              </div>
            </div>
          </slick>
        </div>
        <div class="productInfos">
          <div class="productInfos__nameModel">
            <h1>
              {{ produto.NameComplete }}
            </h1>
            <p><strong>Modelo:</strong> {{ produto.ManufacturerCode }}</p>
            <p>
              <strong>Código de Referência:</strong>
              {{ produto.AlternateIds.RefId }} |
              <span><strong>SKU Interno:</strong> {{ produto.Id }}</span>
            </p>
          </div>

          <div class="productInfos__icons">
            <div class="icons__group" v-if="classeEnergetica == 'Classe A'">
              <p :data="classeEnergetica.substr(7, 8)" class="classeA"></p>
            </div>
            <div class="icons__group" v-if="classeEnergetica == 'Classe B'">
              <p :data="classeEnergetica.substr(7, 8)" class="classeB"></p>
            </div>
            <div class="icons__group" v-if="classeEnergetica == 'Classe C'">
              <p :data="classeEnergetica.substr(7, 8)" class="classeC"></p>
            </div>
            <div class="icons__group" v-if="ciclo == 'Quente e Frio'">
              <img
                src="https://multiar.vteximg.com.br/arquivos/ico-ciclo-quentefrio.png"
                width="20px"
                alt=" "
              />
              <p>{{ ciclo }}</p>
            </div>
            <div class="icons__group" v-if="ciclo == 'Frio'">
              <img
                src="https://multiar.vteximg.com.br/arquivos/ico-ciclo-frio.png"
                width="20px"
                alt=" "
              />
              <p>{{ ciclo }}</p>
            </div>
            <div class="icons__group" v-if="capacidade != null">
              <img
                src="https://multiar.vteximg.com.br/arquivos/tag-capacidade-btu-h.png"
                width="17px"
                alt=" "
              />
              <p>{{ capacidade }}</p>
            </div>
            <div class="icons__group" v-if="voltagem != null">
              <img
                src="https://multiar.vteximg.com.br/arquivos/tag-voltagem.png"
                width="15px"
                alt=" "
              />
              <p>{{ voltagem }}</p>
            </div>
            <div class="icons__group" v-if="tecnologia == 'Inverter'">
              <img
                src="https://multiar.vteximg.com.br/arquivos/ico-inverter.png"
                width="20px"
                alt=" "
              />
              <p>{{ tecnologia }}</p>
            </div>
          </div>

          <div class="productInfos__priceCart">
            <p class="productInfos__priceCart--text">
              <span style="color: #808080;"> {{ precoProduto | toCurrency }}</span>
            </p>
            <h2>
              {{ precoProduto - (precoProduto * 0.02) | toCurrency }}
              <span> à vista </span>
            </h2>
            <button class="productInfos__cart" @click="addMiniCart(produto)">
              <i class="fa fa-cart-plus" aria-hidden="true"></i> Adicionar
              produto ao Carrinho
            </button>
            <p class="productInfos__priceCart--text">
              Vendido e Entregue por <span>Leveros</span>
            </p>
            <div class="productInfos__freigth">
              <p class="productInfos__priceCart--text">Calcular Frete</p>
              <the-mask
                        mask="#####-###"
                        v-model="cep"
                        type="text"
                        placeholder="Informe seu CEP"
                        :masked="false"
                        @change="calcularFrete"
                        class="minicart__input"
                        name="cep"
                        id="cep"
                      />
              <button @click="calcularFrete">
                <i class="fa fa-search" aria-hidden="true"></i>
              </button>
              <p>
                <a
                  href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                  target="_blank"
                  rel="noopener"
                  >Não sei meu CEP</a
                >
              </p>
            </div>
            <div class="freigth__options">
              <div class="loader" v-if="loader">
                <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
                <span>Calculando frete...</span>
              </div>
              <div class="freigth__items" v-for="s in sla" :key="s.tipo">
                <p v-if="s.tipo !== 'Agendada'">
                  <span>{{ s.tipo }}</span> -
                  {{ s.preco | toCurrency }} (Entrega em até {{ s.sla }} dias
                  úteis)
                </p>
                 <p v-else>
                  <span>{{ s.tipo }}</span> -
                  {{ s.preco | toCurrency }} (Verificar datas disponíveis na tela de finalização)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="buyTogether">
        <div class="buyTogether__title">
          <h2>Aproveite e compre junto ;)</h2>
        </div>

        <div class="buyTogether__suggestion">
          <div class="buyTogether__suggestion--product">
            <div class="buyTogether__suggestion--product--image">
              <img
                loading="lazy"
                src="https://multiar.vteximg.com.br/arquivos/ids/196432-125-125/Ar-Condicionado-Springer-Midea-Maxiflex-Leveros.jpg"
                alt=""
              />
            </div>
            <div class="buyTogether__suggestion--product--name">
              <p>
                Ar-Condicionado Split HW Springer Midea MAXIFLEX 12.000 BTUs Só
                Frio 220V
              </p>
            </div>
            <div class="buyTogether__suggestion--product--price">
              <p>R$ 1.471,55 <span>à vista</span></p>
            </div>
          </div>
          <div class="buyTogether__suggestion--plus">+</div>
          <div class="buyTogether__suggestion--service">
            <div class="buyTogether__suggestion--service--image">
              <a href="">
                <img
                  loading="lazy"
                  src="https://multiar.vteximg.com.br/arquivos/ids/187812-125-125/split-instala.jpg?v=636885254433770000"
                  alt=""
                />
              </a>
            </div>
            <div class="buyTogether__suggestion--service--name">
              <p>
                <a href=""
                  >Instalação de Ar-Condicionado Split Parede 7.000 a 10.500
                  BTUs</a
                >
              </p>
            </div>
            <div class="buyTogether__suggestion--service--price">
              <p>R$ 1.471,55 <span>à vista</span></p>
            </div>
          </div>
          <div class="buyTogether__suggestion--igual">=</div>
          <div class="buyTogether__suggestion--buy">
            <p>Compre Ar-Condicionado + Instalação por:</p>
            <p>R$ 1.500,00 <span>à vista</span></p>
            <button>Adicionar ao Carrinho</button>
          </div>
        </div>
      </div> -->

      <div class="productTabs">
        <button
          class="productTabs__tablinks"
          @click="openInfo($event, 'Descricao')"
        >
          DESCRIÇÃO DO PRODUTO
        </button>
        <div
          id="Descricao"
          class="productTabs__tabcontent"
          v-html="produto.ProductDescription"
        ></div>
        <button
          class="productTabs__tablinks"
          @click="openInfo($event, 'Informacoes')"
        >
          INFORMAÇÕES TÉCNICAS
        </button>
        <div
          id="Informacoes"
          class="productTabs__tabcontent"
          v-html="especificacaoTecnica"
        ></div>
        <button
          class="productTabs__tablinks"
          @click="openInfo($event, 'Garantia')"
        >
          GARANTIA
        </button>

        <div
          id="Garantia"
          class="productTabs__tabcontent"
          v-html="garantiaFornecedor"
        ></div>
        <button
          class="productTabs__tablinks"
          @click="openInfo($event, 'Adicionais')"
        >
          INFORMAÇÕES ADICIONAIS
        </button>

        <div
          id="Adicionais"
          class="productTabs__tabcontent"
          v-html="informacoesAdicionais"
        ></div>
      </div>

      <div class="productInfos__buttonBuy">
        <div class="buttonBuy__infos">
          <span> {{ precoProduto | toCurrency }}</span>
          <span>10x de {{ (precoProduto / 10) | toCurrency }} </span>
        </div>
        <button @click="addMiniCart(produto)">
          <i class="fa fa-cart-plus" aria-hidden="true"></i> +Carrinho
        </button>
      </div>
    </div>

    <!-- Custom KIT  -->
    <div v-else>
      <div v-if="solarComponents.length > 0">
        <v-app>
          <div class="details" v-show="enableButton">
            <div class="productDetails">
              <div class="productNameMobile">
                <h1 class="productNameMobile__title">
                  {{ produto.NameComplete }}
                </h1>
              </div>
              <div class="productImages customKit">
                <slick ref="slick" :options="slickOptions">
                  <div
                    class="productImages__images"
                    v-for="(tes, ind) in imagensProduto"
                    :key="ind"
                  >
                    <inner-image-zoom
                      :src="tes.ImageUrl"
                      :alt="produto.NameComplete"
                    />
                    <div class="productImages__quantityImages">
                      {{ ind + 1 }} de {{ imagensProduto.length }}
                    </div>
                  </div>
                </slick>
              </div>
              <div class="productInfos">
                <div class="productInfos__nameModel">
                  <div
                    v-for="(data, indexComponent) in solarComponents"
                    :key="indexComponent"
                    class="ma-4"
                  >
                    <v-card elevation="8">
                      <v-card-title style="font-weight: bold; color: #707070">{{
                        data.component.description
                      }}</v-card-title>
                      <div
                        style="padding: 1em"
                        v-if="data.component.multiple_c == 'S'"
                      >
                        <div
                          v-for="(item, indexItem) in data.itens"
                          :key="indexItem"
                        >
                          <v-row align="center">
                            <v-col class="col-10" v-if="data.itens.length > 1">
                              <v-checkbox
                                v-if="item.description == 'NENHUM'"
                                color="#005a64"
                                v-model="item.checkedItem"
                                :label="item.description"
                                :key="indexItem"
                                @click="removeSelected(data, item.checkedItem)"
                              ></v-checkbox>
                              <v-checkbox
                                v-else
                                :disabled="item.disabled"
                                color="#005a64"
                                v-model="item.checkedItem"
                                :label="item.description"
                                :key="indexItem"
                                @click="getTotalValue()"
                              ></v-checkbox>
                            </v-col>
                            <v-col class="col-10" v-else>
                              <v-checkbox
                                v-if="item.description == 'NENHUM'"
                                disabled
                                color="#005a64"
                                v-model="item.checkedItem"
                                :label="item.description"
                                :key="indexItem"
                                @click="removeSelected(data, item.checkedItem)"
                              ></v-checkbox>
                              <v-checkbox
                                v-else
                                disabled
                                color="#005a64"
                                v-model="item.checkedItem"
                                :label="item.description"
                                :key="indexItem"
                                @click="getTotalValue()"
                              ></v-checkbox>
                            </v-col>
                            <v-col style="align-self: center !important">
                              <template>
                                <v-tooltip left>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-if="item.description != 'NENHUM'"
                                      fab
                                      outlined
                                      x-small
                                      color="#005a64"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon>mdi-information-variant</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-card elevation="8" class="pa-1">
                                    <v-card-title>{{
                                      item.description
                                    }}</v-card-title>
                                    <div class="ml-6 mr-6">
                                      {{ item.descriptionItem }}
                                    </div>
                                    <v-img
                                      class="imgCenter"
                                      style="border-radius: 10px;"
                                      :src="item.imgItem"
                                      min-height="550px"
                                    ></v-img>
                                  </v-card>
                                </v-tooltip>
                              </template>
                            </v-col>
                          </v-row>
                          <div
                            style="padding: 1em; text-align: right"
                            v-if="
                              item.description != 'NENHUM' && item.checkedItem
                            "
                          >
                            <span style="color: #707070; font-size: 1.2rem"
                              >Quantidade:
                            </span>
                            <v-btn
                              fab
                              outlined
                              x-small
                              :disabled="!item.checkedItem"
                              @click="decrement(item)"
                              v-longclick="() => decrement(item)"
                            >
                              <v-icon dark> mdi-minus </v-icon>
                            </v-btn>
                            <span style="font-weight: bold">
                              {{ item.sug }}
                            </span>
                            <v-btn
                              fab
                              outlined
                              x-small
                              :disabled="!item.checkedItem"
                              @click="increment(item)"
                              v-longclick="() => increment(item)"
                            >
                              <v-icon dark> mdi-plus </v-icon>
                            </v-btn>
                          </div>
                          <div v-if="item.description != 'NENHUM' && item.checkedItem && item.bloqueios.length > 0">
                            <v-alert 
                              outlined 
                              :color="
                                item.validaEstoque === 'A' && item.prazoEstoque ?
                                'warning' : item.validaEstoque === 'E' && item.prazoEstoque ?
                                'info' : item.validaEstoque === 'P' && item.prazoEstoque ?
                                'success' : 'error'"
                              style="padding: 12px; font-size: 14px;">
                              
                              <div class="mb-2">
                                {{
                                  item.validaEstoque === 'A' ?
                                  mensagemAlertaEstoque : item.validaEstoque === 'E' ?
                                  mensagemAlertaEncomenda : item.validaEstoque === 'P' ?
                                  mensagemAlertaPreVenda : mensagemBloquioEstoque
                                }}
                              </div>

                              <div class="mb-2" v-if="item.prazoEstoque && item.validaEstoque == 'E' || item.validaEstoque == 'A'">
                                Previsão de chegada em estoque: {{ item.prazoEstoque }} dias
                              </div>
                              <div class="mb-2" v-if="item.prazoEstoque && item.validaEstoque == 'P'">
                                Previsão de chegada em estoque: {{ item.prazoEstoque }} 
                              </div>
                              <div class="mb-2" v-else>
                                Consultar prazo de entrega com o vendedor.
                              </div>

                              <div v-for="(bloq, i) in item.bloqueios" :key="i">
                                {{ bloq.dsProduct }}
                              </div>
                            </v-alert>
                          </div>
                          <v-divider
                            v-if="indexItem < data.itens.length - 1"
                          ></v-divider>
                        </div>
                      </div>
                      <div v-else-if="data.component.multiple_c == 'N' && data.component.id === 10">
                        <div class="pa-4">
                          <v-select
                            v-if="fitrosMotobomba.categorias && fitrosMotobomba.categorias.length > 0"
                            v-model="categoriaMotobomba"
                            color="#002d32"
                            :items="fitrosMotobomba.categorias"
                            label="Categoria"
                            item-text="desc"
                            item-value="desc"
                            item-disabled="disabled"
                            clearable
                            @change="verificaFiltros()"
                          ></v-select>
                          <div class="row">
                            <div class="col" v-if="fitrosMotobomba.potencia_cv && fitrosMotobomba.potencia_cv.length > 0">
                              <v-select
                                v-model="potenciaMotobomba"
                                color="#002d32"
                                :items="fitrosMotobomba.potencia_cv"
                                label="Potência"
                                item-text="desc"
                                item-value="desc"
                                item-disabled="disabled"
                                clearable
                                @change="verificaFiltros()"
                              ></v-select>
                            </div>
                            <div class="col" v-if="fitrosMotobomba.estagios && fitrosMotobomba.estagios.length > 0">
                              <v-select
                                v-model="estagiosMotobomba"
                                :items="fitrosMotobomba.estagios"
                                color="#002d32"
                                label="Estágios"
                                item-text="desc"
                                item-value="desc"
                                item-disabled="disabled"
                                clearable
                                @change="verificaFiltros()"
                              ></v-select>
                            </div>
                          </div>
                        </div>
                        <div>
                          <template>
                            <v-data-table
                              width="100%"
                              :headers="headers"
                              :items="data.itens"
                              :items-per-page="5"
                              :footer-props="{
                                'items-per-page-text':'Itens por página'
                              }"
                              class="overflow-y-hidden overflow-x-hidden"
                            >
                              <template slot="no-data">
                                <div>Nenhum item á ser exibido</div>
                              </template>
                              
                              <template slot="no-results">
                                <div>Nenhum item correspondente aos filtros</div>
                              </template>

                              <template v-slot:item="{ item }" width="100%">
                                <div v-if="item.description !== 'NENHUM'">
                                  <v-row class="pl-4" style="width: 100%">
                                    <v-col class="col-10">
                                      <input
                                        type="radio"
                                        :id="item.id"
                                        v-model="data.checked"
                                        style="cursor: pointer"
                                        :name="'comp' + indexComponent"
                                        :value="item"
                                        @change="getTotalValue()"
                                      />
                                      <label
                                        :for="item.id"
                                        style="
                                          color: rgba(0, 0, 0, 0.6);
                                          user-select: none;
                                          cursor: pointer;
                                        "
                                      >
                                        {{ item.description }}
                                      </label>
                                    </v-col>
                                    <v-col style="align-self: center !important">
                                      <template>
                                        <v-tooltip left>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              v-if="item.description != 'NENHUM'"
                                              fab
                                              outlined
                                              x-small
                                              color="#005a64"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>mdi-information-variant</v-icon>
                                            </v-btn>
                                          </template>
                                          <v-card elevation="8">
                                            <v-card-title>{{
                                              item.description
                                            }}</v-card-title>
                                            <div class="ml-6 mr-6">
                                              {{ item.descriptionItem }}
                                            </div>
                                            <v-img
                                              class="imgCenter"
                                              style="border-radius: 10px;"
                                              :src="item.imgItem"
                                              min-height="550px"
                                            ></v-img>
                                          </v-card>
                                        </v-tooltip>
                                      </template>
                                    </v-col>
                                  </v-row>
                                  <br /><br />
                                </div>
                              </template>

                              <template v-slot:footer="{}">
                                <div
                                  v-for="(item, indexItem) in data.itens"
                                  :key="indexItem"
                                >
                                  <div v-if="item.description === 'NENHUM'">
                                    <v-row 
                                      align="center"
                                      class="pl-4"
                                      style="width: 100%" 
                                    >
                                      <v-col class="col-10">
                                        <input
                                          type="radio"
                                          :id="item.id"
                                          v-model="data.checked"
                                          style="cursor: pointer"
                                          :name="'comp' + indexComponent"
                                          :value="item"
                                          @change="getTotalValue()"
                                        />
                                        <label
                                          :for="item.id"
                                          style="
                                            color: rgba(0, 0, 0, 0.6);
                                            user-select: none;
                                            cursor: pointer;
                                          "
                                        >
                                          {{ item.description }}
                                        </label>
                                      </v-col>
                                      <v-col style="align-self: center !important">
                                        <template>
                                          <v-tooltip left>
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                v-if="item.description != 'NENHUM'"
                                                fab
                                                outlined
                                                x-small
                                                color="#005a64"
                                                v-bind="attrs"
                                                v-on="on"
                                              >
                                                <v-icon>mdi-information-variant</v-icon>
                                              </v-btn>
                                            </template>
                                            <v-card elevation="8">
                                              <v-card-title>{{
                                                item.description
                                              }}</v-card-title>
                                              <div class="ml-6 mr-6">
                                                {{ item.descriptionItem }}
                                              </div>
                                              <v-img
                                                class="imgCenter"
                                                style="border-radius: 10px;"
                                                :src="item.imgItem"
                                                min-height="550px"
                                              ></v-img>
                                            </v-card>
                                          </v-tooltip>
                                        </template>
                                      </v-col>
                                    </v-row>
                                    <br>
                                  </div>
                                </div>
                              </template>

                              <template v-slot:[`footer.page-text`]="items"> 
                                {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                              </template>
                            </v-data-table>
                          </template>

                          <div v-if="data.checked.description != 'NENHUM'">
                            <v-divider></v-divider>
                          </div>

                          <div v-if="data.checked.description != 'NENHUM'" style="padding: 1em;">
                            <div>
                              <div style="color: rgba(0, 0, 0, 0.6);">Motobomba selecionada:</div>
                              <br>
                              <div style="color: #707070; font-size: 1.2rem">
                                {{ data.checked.description }}
                              </div>
                            </div>
                            <div style="text-align: right">
                              <br>
                              <span style="color: #707070; font-size: 1.2rem"
                                >Quantidade:
                              </span>
                              <v-btn
                                fab
                                outlined
                                x-small
                                @click="decrement(data.checked)"
                                v-longclick="() => decrement(data.checked)"
                              >
                                <v-icon dark> mdi-minus </v-icon>
                              </v-btn>
                              <span style="font-weight: bold">
                                {{ data.checked.sug }}
                              </span>
                              <v-btn
                                fab
                                outlined
                                x-small
                                @click="increment(data.checked)"
                                v-longclick="() => increment(data.checked)"
                              >
                                <v-icon dark> mdi-plus </v-icon>
                              </v-btn>
                            </div>
                            <div v-if="data.checked.description != 'NENHUM' && data.checked.bloqueios.length > 0">

                              <v-alert 
                                outlined 
                                :color="
                                  data.checked.validaEstoque === 'A' && data.checked.prazoEstoque ?
                                  'warning' : data.checked.validaEstoque === 'E' && data.checked.prazoEstoque ?
                                  'info' : data.checked.validaEstoque === 'P' && data.checked.prazoEstoque ?
                                  'success' : 'error'"
                                style="padding: 12px; font-size: 14px;"
                                class="mt-4">
                                
                                <div class="mb-2">
                                  {{
                                    data.checked.validaEstoque === 'A' ?
                                    mensagemAlertaEstoque : data.checked.validaEstoque === 'E' ?
                                    mensagemAlertaEncomenda : data.checked.validaEstoque === 'P' ?
                                    mensagemAlertaPreVenda : mensagemBloquioEstoque
                                  }}
                                </div>

                                <div class="mb-2" v-if="data.checked.prazoEstoque && data.checked.validaEstoque == 'E' || data.checked.validaEstoque == 'A'">
                                  Previsão de chegada em estoque: {{ data.checked.prazoEstoque }} dias
                                </div>
                                <div class="mb-2" v-if="data.checked.prazoEstoque && data.checked.validaEstoque == 'P'">
                                  Previsão de chegada em estoque: {{ data.checked.prazoEstoque }} 
                                </div>
                                <div class="mb-2" v-else>
                                  Consultar prazo de entrega com o vendedor.
                                </div>

                                <div v-for="(bloq, i) in data.checked.bloqueios" :key="i">
                                  {{ bloq.dsProduct }}
                                </div>
                              </v-alert>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else style="padding: 1em">
                        <v-row
                          align="center"
                          v-for="(item, indexItem) in data.itens"
                          :key="indexItem"
                        >
                          <v-col class="col-10">
                            <input
                              type="radio"
                              :id="item.id"
                              v-model="data.checked"
                              style="cursor: pointer"
                              :name="'comp' + indexComponent"
                              :value="item"
                              @change="getTotalValue()"
                            />
                            <label
                              :for="item.id"
                              style="
                                color: rgba(0, 0, 0, 0.6);
                                user-select: none;
                                cursor: pointer;
                              "
                            >
                              {{ item.description }}
                            </label>
                          </v-col>
                          <v-col style="align-self: center !important">
                            <template>
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="item.description != 'NENHUM'"
                                    fab
                                    outlined
                                    x-small
                                    color="#005a64"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-information-variant</v-icon>
                                  </v-btn>
                                </template>
                                <v-card elevation="8">
                                  <v-card-title>{{
                                    item.description
                                  }}</v-card-title>
                                  <div class="ml-6 mr-6">
                                    {{ item.descriptionItem }}
                                  </div>
                                  <v-img
                                    class="imgCenter"
                                    style="border-radius: 10px;"
                                    :src="item.imgItem"
                                    min-height="550px"
                                  ></v-img>
                                </v-card>
                              </v-tooltip>
                            </template>
                          </v-col>
                        </v-row>
                        <br /><br />
                        <div
                          v-if="data.checked.description != 'NENHUM'"
                          style="text-align: right"
                        >
                          <span style="color: #707070; font-size: 1.2rem"
                            >Quantidade:
                          </span>
                          <v-btn
                            fab
                            outlined
                            x-small
                            @click="decrement(data.checked)"
                            v-longclick="() => decrement(data.checked)"
                          >
                            <v-icon dark> mdi-minus </v-icon>
                          </v-btn>
                          <span style="font-weight: bold">
                            {{ data.checked.sug }}
                          </span>
                          <v-btn
                            fab
                            outlined
                            x-small
                            @click="increment(data.checked)"
                            v-longclick="() => increment(data.checked)"
                          >
                            <v-icon dark> mdi-plus </v-icon>
                          </v-btn>
                        </div>
                        <div v-if="data.checked.description != 'NENHUM' && data.checked.bloqueios.length > 0">

                          <v-alert 
                            outlined 
                            :color="
                              data.checked.validaEstoque === 'A' && data.checked.prazoEstoque ?
                              'warning' : data.checked.validaEstoque === 'E' && data.checked.prazoEstoque ?
                              'info' : data.checked.validaEstoque === 'P' && data.checked.prazoEstoque ?
                              'success' : 'error'
                            "
                            style="padding: 12px; font-size: 14px;"
                            class="mt-4">
                            
                            <div class="mb-2">
                              {{ data.checked.validaEstoque === 'A' ?
                                  mensagemAlertaEstoque : data.checked.validaEstoque === 'E' ?
                                  mensagemAlertaEncomenda : data.checked.validaEstoque === 'P' ?
                                  mensagemAlertaPreVenda : mensagemBloquioEstoque
                              }}
                            </div>

                            <div class="mb-2" v-if="data.checked.prazoEstoque">
                              Previsão de chegada em estoque: {{ data.checked.prazoEstoque }}
                            </div>
                            <div class="mb-2" v-else>
                              Consultar prazo de entrega com o vendedor.
                            </div>

                            <div v-for="(bloq, i) in data.checked.bloqueios" :key="i">
                              {{ bloq.dsProduct }}
                            </div>
                          </v-alert>

                          <!-- Alerta de estoque -->
                          <!-- <div v-if="data.checked.validaEstoque === 'A'">
                            <div v-if="data.checked.sug > data.checked.estoque">
                              <br>
                              <v-alert outlined color="warning" style="padding: 12px; font-size: 14px;">
                                {{ mensagemAlertaEstoque }}
                              </v-alert>
                            </div>
                          </div> -->
                          <!-- Alerta produto encomenda -->
                          <!-- <div v-if="data.checked.validaEstoque === 'E'">
                            <br>
                            <v-alert outlined color="info" style="padding: 12px; font-size: 14px;">
                              {{ mensagemAlertaEncomenda }}
                            </v-alert>
                          </div> -->
                          <!-- Valida estoque -->
                          <!-- <div v-if="data.checked.validaEstoque === 'X'">
                            <br>
                            <div v-if="data.checked.sug > data.checked.estoque">
                              <v-alert outlined color="error" style="padding: 12px; font-size: 14px;">
                                {{ mensagemBloquioEstoque }}
                              </v-alert>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <div v-if="data.component.id == 1 && calculoPotencia">
                        <v-divider></v-divider>
                        <div style="padding: 20px">
                          <div style="color: #707070; font-size: 1.2rem">
                            Potência Total do Gerador: {{ potenciaTotal }} kW
                          </div>
                          <div
                            style="color: red; font-size: 0.9rem"
                            v-if="mensagemPotencia"
                          >
                            {{ mensagemPotencia }}
                          </div>
                        </div>
                        <div v-if="fatorSobrecarga !== 0">
                          <v-divider></v-divider>
                          <div style="padding: 20px">
                            <div style="color: #707070; font-size: 1.2rem">
                              Fator de sobrecarga do inversor:
                              <span
                                :style="fatorSobrecargaCor ? `color: ${fatorSobrecargaCor};` : true"
                              >{{ fatorSobrecarga }}%</span>
                            </div>
                            <div
                              :style="fatorSobrecargaCor ? `color: ${fatorSobrecargaCor};` : true"
                              style="font-size: 1.2rem"
                            >
                              {{fatorSobrecargaMensagem}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="data.component.id == 2 && calculoPotencia">
                        <v-divider></v-divider>
                        <div style="padding: 20px">
                          <div style="color: #707070; font-size: 1.2rem">
                            Potência Total do Módulo: {{ potenciaTotalModulos }} kWp
                          </div>
                        </div>
                      </div>
                      <div v-if="data.component.id == 6">
                        <v-divider></v-divider>
                        <div style="padding: 20px">
                          <div style="color: #707070; font-size: 1.2rem">
                            Total de Módulos Suportados: {{ totalModulosSuportados }}
                          </div>
                          <div
                            style="color: red; font-size: 0.9rem"
                            v-if="mensagemEstrutura"
                          >
                            {{ mensagemEstrutura }}
                          </div>
                        </div>
                      </div>
                    </v-card>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <div class="summary" id="summary">
              <v-row no-gutters>
                <v-col cols="12" sm="6">
                  <h2>Resumo:</h2>
                  <div
                    v-for="(data, indexComponent) in solarComponents"
                    :key="'summary' + indexComponent"
                  >
                    <h4>{{ data.component.description }}</h4>
                    <div v-if="data.component.multiple_c == 'S'">
                      <div
                        v-for="(item, indexItem) in data.itens"
                        :key="'summary' + indexItem"
                      >
                        <div v-if="item.checkedItem" class="summary_list">
                          {{ item.sug }}
                          <span v-if="item.description != 'NENHUM'"> x </span>
                          {{ item.description }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="summary_list">
                        {{ data.checked.sug }}
                        <span v-if="data.checked.description != 'NENHUM'">
                          x
                        </span>
                        {{ data.checked.description }}
                      </div>
                    </div>
                  </div>
                  <!-- Detalhes -->
                  <div>
                    <br />
                    <h2>Detalhes:</h2>
                    <div
                      v-for="(comp, indexComp) in arraySummary"
                      :key="'detail' + indexComp"
                    >
                      <div
                        v-for="(item, indexItem) in comp.itens"
                        :key="'item' + indexItem"
                        class="summary_list"
                        style="font-size: small"
                      >
                        {{ item.quantidade }} x {{ item.descricao }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: center">
                  <h2>
                    {{ produto.NameComplete }}
                  </h2>
                  <p><strong>Modelo:</strong> {{ produto.ManufacturerCode }}</p>
                  <p>
                    <strong>Código de Referência:</strong>
                    {{ produto.AlternateIds.RefId }} |
                    <span><strong>SKU Interno:</strong> {{ produto.Id }}</span>
                  </p>

                  <!-- Valida se possui inversor selecionado e se pode exibir os preços -->
                  <div v-if="exibeValorKit">
                    <h2>
                      {{ totalValueSolar | toCurrency }}
                    </h2>

                    <h2 style="color: red !important; opacity: 0.7">
                      {{
                        (totalValueSolar - totalValueSolar * (descontoSolar / 100))
                          | toCurrency
                      }}
                      <span> à vista </span>
                    </h2>
                    <h2 style="font-size: small">
                      Preço: de {{ moment(validadeDe).format("DD/MM/YYYY") }} até
                      {{ moment(validadeAte).format("DD/MM/YYYY") }}
                    </h2>
                    <br><br>
                    <div class="minicart__shipping"><div class="minicart__title"></div></div>
                    <div class="minicart__shipping">
                      <div class="minicart__title">
                        <h3>Calcular Frete</h3>
                      </div>
                      <div class="minicart__calculate">
                        <the-mask
                          mask="#####-###"
                          v-model="cep"
                          type="text"
                          placeholder="Informe seu CEP"
                          :masked="false"
                          @change="calcularFrete"
                          class="minicart__input"
                          name="cep"
                          id="cep"
                        />
                        <button class="minicart__buttonSearch" @click="calcularFrete">
                          <img
                            loading="lazy"
                            src="../../assets/icon_search.png"
                            alt="Calcular Frete"
                          />
                        </button>
                        <p class="minicart__toKnowCEP">
                          <a
                            href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                            target="_blank"
                            rel="noopener"
                            >Não sei meu CEP</a
                          >
                        </p>
                      </div>
                      <div class="minicart__options">
                        <div class="minicart__loader" v-if="loader">
                          <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
                          <span>Calculando frete...</span>
                        </div>

                        <v-radio-group v-if="!loader">
                          <v-radio
                            v-for="s in sla"
                            :key="s.tipo"
                            :label="s.textoFrete"
                            @change="selecionaSLA(s)"
                            :value="s.sla"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </div>
                    <div class="minicart__totals">
                      <ul>
                        <li>
                          <strong>SUBTOTAL</strong>
                          <span> {{ totalValueSolar | toCurrency }}</span>
                        </li>
                        <li>
                          <strong>FRETE</strong>
                          <span v-if="slaSelecionado == null">A Calcular</span>
                          <span v-if="slaSelecionado != null">
                            {{ slaSelecionado.preco | toCurrency }}</span
                          >
                        </li>
                        <li>
                          <strong>TOTAL</strong>
                          <span v-if="slaSelecionado != null">
                            {{ (totalValueSolar + slaSelecionado.preco) | toCurrency }}</span
                          >
                          <span v-if="slaSelecionado == null">
                            {{ totalValueSolar | toCurrency }}</span
                          >
                        </li>
                        <li>
                          <strong>TOTAL A VISTA </strong>
                          <span v-if="slaSelecionado != null">
                            {{ ((totalValueSolar -totalValueSolar *(descontoSolar / 100)) + slaSelecionado.preco) | toCurrency }}</span
                          >
                          <span v-if="slaSelecionado == null">
                            {{ (totalValueSolar -totalValueSolar *(descontoSolar / 100))  | toCurrency }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-else>
                    <p><strong>Selecione um inversor para exibir o valor</strong></p>
                  </div>
                  <div>
                    <div class="minicart__shipping"><div class="minicart__title"></div></div>
                    <div class="minicart__shipping">
                      <div class="minicart__title">
                        <h3>Detalhes do Orçamento</h3>
                      </div>
                    </div>
                    <div class="form-groups">
                      <div class="row">
                        <div class="col-4" style="text-align: right;">
                          <label class="label">Nome Cliente:</label>
                        </div>
                        <div class="col-6">
                          <input
                            name="nome"
                            id="nome"
                            style="width: 100%;"
                            v-model="nomeCliente"
                            type="text"
                            class="input medium"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-groups">
                      <div class="row">
                        <div class="col-4" style="text-align: right;">
                          <label class="label">CNPJ/CPF Cliente:</label>
                        </div>
                        <div class="col-6">
                          <input
                            name="cpfCnpj"
                            id="cpfCnpj"
                            style="width: 100%;"
                            v-model="CnpjCpf"
                            type="text"
                            class="input medium"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-groups">
                      <div class="row">
                        <div class="col-4" style="text-align: right;">
                          <label class="label">Número Proposta:</label>
                        </div>
                        <div class="col-6">
                          <input
                            name="proposta"
                            id="proposta"
                            style="width: 100%;"
                            v-model="NrProposta"
                            type="text"
                            class="input medium"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-groups">
                      <div class="row">
                        <div class="col-4" style="text-align: right;">
                          <label class="label">E-mail adicional:</label>
                        </div>
                        <div class="col-6">
                          <input
                            name="emailAdicional"
                            style="width: 100%;"
                            id="emailAdicional"
                            type="text"
                            class="input medium"
                          />
                        </div>
                      </div>
                    </div>
                    <br/>
                  </div>
                  <div class="minicart__shipping"><div class="minicart__title"></div></div>
                  <div style="text-align: -webkit-center">
                    <button
                      class="productInfos__cart"
                      style="text-align: center"
                      @click="addMiniCart(produto)"
                    >
                      <i class="fa fa-cart-plus" aria-hidden="true"></i>
                      Adicionar produto ao Carrinho
                    </button>
                    <br>
                    <button
                      @click="sendBudget()"
                      class="productInfos__cart"
                      style="background: #ffce00; color: #005a64"
                    >
                      Gerar orçamento
                    </button>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-app>

        <div style="display: none">
          <div id="summaryEmail">
            <body leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">
              <center>
                <table
                  width="600"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  style="font-family: Arial, Helvetica, sans-serif"
                  role="presentation"
                >
                  <tr>
                    <td style="background-color: #002d32; height: 56px">
                      <table
                        width="100%"
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        role="presentation"
                      >
                        <tbody>
                          <tr>
                            <td>
                              <center>
                                <img
                                  src="https://multiar.vteximg.com.br/arquivos/logo-leveros-solar-emkt.png"
                                  alt="Logo Leveros Solar"
                                />
                              </center>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <center>
                        <table
                          width="510"
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          style="padding: 40px 0 0 0; color: #7a7a7a"
                          role="presentation"
                        >
                          <tbody>
                            <tr>
                              <td style="width: 60%">
                                <p style="color: #28565f">
                                  <strong>Olá, Parceiro.</strong>
                                </p>
                                <p>
                                  Obrigado por fazer um orçamento de
                                  <strong style="color: #005a64"
                                    >Kit Fotovoltaico</strong
                                  >
                                  com a
                                  <strong style="color: #f2c016"
                                    >Leveros Solar</strong
                                  >. Para concluir seu pedido, entre em contato
                                  com nossos vendedores:
                                </p>
                              </td>

                              <td style="width: 40%; text-align: right">
                                <img
                                  src="https://multiar.vteximg.com.br/arquivos/imagem-energia-solar-emkt.png"
                                  alt="Kit Fotovoltaico"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          width="510"
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          style="color: #7a7a7a"
                          role="presentation"
                        >
                          <tr>
                            <td>
                              <img
                                src="https://multiar.vteximg.com.br/arquivos/icone-chat-emkt-solar.png"
                                alt="Ícone contatos Leveros Solar"
                              />
                            </td>
                            <td>
                              <strong>E-mail:</strong>
                              comercial.solar@leveros.com.br<br />
                              <strong>Telefone Comercial:</strong> (47)
                              3053-2630<br />
                              <strong>Whatsapp Comercial:</strong> (47) 9
                              9795-0218
                            </td>
                          </tr>
                        </table>
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding: 40px 0 0 0">
                      <center>
                        <table
                          width="510px"
                          border="0"
                          cellpadding="0"
                          cellspacing="0"
                          style="
                            padding: 30px;
                            border: 1px solid #e5e5e5;
                            border-radius: 12px;
                            color: #7a7a7a;
                          "
                          role="presentation"
                        >
                          <tbody>
                            <tr>
                              <td colspan="3">
                                <p
                                  style="
                                    font-size: 17px;
                                    color: #f2c016;
                                    font-weight: bold;
                                    padding: 0 0 25px 0;
                                  "
                                >
                                  Resumo do seu orçamento:
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table>
                                  <tr>
                                    <td>
                                      <table
                                        border="0"
                                        style="color: #7a7a7a; font-size: 15px"
                                        role="presentation"
                                      >
                                        <tr v-if="!slaSelecionado">
                                          <th style="width: 50%">
                                            {{ produto.NameComplete }}
                                          </th>
                                          <th style="">
                                          {{ totalValueSolar | toCurrency }}
                                            <br />
                                            <span
                                              style="
                                                color: red !important;
                                                opacity: 0.7;
                                              "
                                              >{{
                                                (totalValueSolar -
                                                  totalValueSolar *
                                                    (descontoSolar / 100))
                                                  | toCurrency
                                              }}
                                              à vista</span
                                            >
                                            <br />
                                            <span style="font-size: small"
                                              >Preço: de
                                              {{
                                                moment(validadeDe).format(
                                                  "DD/MM/YYYY"
                                                )
                                              }}
                                              até
                                              {{
                                                moment(validadeAte).format(
                                                  "DD/MM/YYYY"
                                                )
                                              }}</span
                                            >
                                          </th>
                                        </tr>
                                        <tr v-else>
                                          <th style="width: 50%">
                                            {{ produto.NameComplete }}
                                          </th>
                                          <th style="">
                                            Subtotal: {{ totalValueSolar | toCurrency }}
                                            <br />
                                            Frete: {{ slaSelecionado.preco | toCurrency }} 
                                            <br />
                                            Valor total: {{ totalValueSolar + slaSelecionado.preco | toCurrency }}
                                            <span
                                              style="
                                                color: red !important;
                                                opacity: 0.7;
                                              "
                                              >{{
                                                (totalValueSolar -
                                                  totalValueSolar *
                                                    (descontoSolar / 100)) + slaSelecionado.preco
                                                  | toCurrency
                                              }}
                                              à vista</span
                                            >
                                            <br />
                                            <span style="font-size: small"
                                              >Preço: de
                                              {{
                                                moment(validadeDe).format(
                                                  "DD/MM/YYYY"
                                                )
                                              }}
                                              até
                                              {{
                                                moment(validadeAte).format(
                                                  "DD/MM/YYYY"
                                                )
                                              }}</span
                                            >
                                          </th>
                                        </tr>
                                        <tr></tr>
                                      </table>
                                      <table
                                        border="0"
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="color: #7a7a7a; font-size: 12px"
                                        role="presentation"
                                      >
                                        <tr>
                                          <td>
                                            <div
                                              v-for="(
                                                data, indexComponent
                                              ) in solarComponents"
                                              :key="'summary' + indexComponent"
                                            >
                                              <h4>
                                                {{ data.component.description }}
                                              </h4>
                                              <div
                                                v-if="
                                                  data.component.multiple_c == 'S'
                                                "
                                              >
                                                <div
                                                  v-for="(
                                                    item, indexItem
                                                  ) in data.itens"
                                                  :key="'summary' + indexItem"
                                                >
                                                  <div
                                                    v-if="item.checkedItem"
                                                    class="summary_list"
                                                  >
                                                    {{ item.sug }}
                                                    <span
                                                      v-if="
                                                        item.description !=
                                                        'NENHUM'
                                                      "
                                                    >
                                                      x
                                                    </span>
                                                    {{ item.description }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div v-else>
                                                <div class="summary_list">
                                                  {{ data.checked.sug }}
                                                  <span
                                                    v-if="
                                                      data.checked.description !=
                                                      'NENHUM'
                                                    "
                                                  >
                                                    x
                                                  </span>
                                                  {{ data.checked.description }}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <br /><br />
                            <tr>
                              <td colspan="3">
                                <p
                                  style="
                                    font-size: 17px;
                                    color: #f2c016;
                                    font-weight: bold;
                                    padding: 0 0 25px 0;
                                  "
                                >
                                  Detalhes:
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table>
                                  <tr>
                                    <td>
                                      <table
                                        border="0"
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="color: #7a7a7a; font-size: 12px"
                                        role="presentation"
                                      >
                                        <tr>
                                          <td>
                                            <div
                                              v-for="(
                                                comp, indexComp
                                              ) in arraySummary"
                                              :key="'detail_email' + indexComp"
                                            >
                                              <div
                                                v-for="(
                                                  item, indexItem
                                                ) in comp.itens"
                                                :key="'item_email' + indexItem"
                                                class="summary_list"
                                                style="font-size: small"
                                              >
                                                {{ item.quantidade }} x
                                                {{ item.descricao }}
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </center>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding: 25px 0 0 0">
                      <table
                        border="0"
                        style="
                          padding: 20px 0;
                          background-color: #f2c016;
                          width: 100%;
                        "
                        role="presentation"
                      >
                        <tbody>
                          <tr>
                            <td style="width: 35%; padding: 0 0 0 50px">
                              <p
                                style="
                                  color: #fff;
                                  font-weight: bold;
                                  font-size: 17px;
                                "
                              >
                                Siga nossas redes sociais e fique por dentro das
                                nossas novidades!
                              </p>
                            </td>
                            <td
                              style="
                                width: 20%;
                                text-align: right;
                                padding: 0 15px 0 0;
                              "
                            >
                              <a
                                href="https://www.instagram.com/leverossolar/"
                                target="_blank"
                              >
                                <img
                                  src="https://multiar.vteximg.com.br/arquivos/icone-instagram-solar-emkt.png"
                                  alt="Ícone Instagram Leveros Solar"
                                />
                              </a>
                            </td>
                            <td style="width: 10%">
                              <a
                                href="https://www.facebook.com/leverossolar/"
                                target="_blank"
                              >
                                <img
                                  src="https://multiar.vteximg.com.br/arquivos/icone-facebook-solar-emkt.png"
                                  alt="Ícone Facebook Leveros Solar"
                                />
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding: 30px 0 0 0">
                      <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        role="presentation"
                      >
                        <tbody>
                          <tr>
                            <td
                              style="
                                text-align: center;
                                font-size: 10px;
                                color: #7a7a7a;
                              "
                            >
                              <p>
                                Todos o nossos e-mails têm link direto para nosso
                                site ou sites parceiros e em nenhuma hipótese
                                trazem arquivos anexos executáveis ou links para
                                download.<br />
                                Pedimos que desconsidere qualquer e-mail enviado
                                com estas características.
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </center>
            </body>
          </div>
        </div>
      </div>
      <div v-else style="height: 400px"></div>
    </div>

    <v-dialog v-model="dialog.active" width="500">
      <v-card>
        <v-card-title
          class="headline"
          style="
            background: rgb(255, 206, 0);
            color: rgb(0, 90, 100);
            font-weight: bold;
          "
        >
          {{ dialog.title }}
        </v-card-title>
        <v-card-text
          class="mt-6"
          v-html="dialog.message"
          style="font-size: initial !important"
        >
          {{ dialog.message }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog.active = false"
            style="background-color: rgb(0, 90, 100)"
          >
            <span style="color: white">OK</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogValidations.active" width="80%">
      <v-card>
        <v-card-title
          class="headline"
          style="
            background: rgb(255, 206, 0);
            color: rgb(0, 90, 100);
            font-weight: bold;
          "
        >
          Atenção!
        </v-card-title>
        <v-card-text
          class="mt-6"
          style="font-size: initial !important"
        >
          <v-card
            class="d-flex justify-center"
            flat
            tile
          >
            <v-card
              class="pa-2 ma-2 cardAlert--red"
              width="100%"
              outlined
              tile
              v-if="arrValidacaoEstoque.length > 0"
            >
              <div>
                <p><b>Os itens abaixo não possuem estoque disponiveis no momento:</b></p>
                <br>
                <ul>
                  <li v-for="(item, indexItem) in arrValidacaoEstoque" :key="indexItem">
                    {{ item.dsProduct }} {{ item.prazoEstoque ? " - Disponibilidade em estoque: " + item.prazoEstoque  + " dias" : " - Consulte o prazo de entrega!" }}
                  </li>
                </ul>
                <br>
                <p><b>Verifique com seu consultor de vendas!</b></p>
                <br>
                <p><b>*Não é permitido seguir com o pedido</b></p>
              </div>
            </v-card>
            <v-card
              width="100%"
              class="pa-2 ma-2 cardAlert--customYellow"
              outlined
              tile
              v-if="arrAlertaEstoque.length > 0"
            >
              <div>
                <p><b>Os itens abaixo se encontram indisponíveis no momento!</b></p>
                <br>
                <ul>
                  <li v-for="(item, indexItem) in arrAlertaEstoque" :key="indexItem">
                    {{ item.dsProduct }} {{ item.prazoEstoque ? " - Disponibilidade em estoque: " + item.prazoEstoque  + " dias" : " - Consulte o prazo de entrega!" }}
                  </li>
                </ul>
              </div>
            </v-card>
            <v-card
              width="100%"
              class="pa-2 ma-2 cardAlert--customBlue"
              outlined
              tile
              v-if="arrAlertaEncomenda.length > 0"
            >
              <div>
                <p><b>Os itens abaixo são disponibilizados sob encomenda!</b></p>
                <br>
                <ul>
                  <li v-for="(item, indexItem) in arrAlertaEncomenda" :key="indexItem">
                    {{ item.dsProduct }} {{ item.prazoEstoque ? " - Disponibilidade em estoque: " + item.prazoEstoque  + " dias" : " - Consulte o prazo de entrega!" }}
                  </li>
                </ul>
              </div>
            </v-card>
            <v-card
              width="100%"
              class="pa-2 ma-2 cardAlert--customGreen"
              outlined
              tile
              v-if="arrAlertaPreVenda.length > 0"
            >
              <div>
                <p><b>Os itens abaixo são disponibilizados sob pré-venda!</b></p>
                <br>
                <ul>
                  <li v-for="(item, indexItem) in arrAlertaPreVenda" :key="indexItem">
                    {{ item.dsProduct }} {{ item.prazoEstoque ? " - Disponibilidade em estoque: " + item.prazoEstoque : " - Consulte o prazo de entrega!" }}
                  </li>
                </ul>
              </div>
            </v-card>
          </v-card>
          <!-- {{ dialog.message }} -->
        </v-card-text>
        <v-card-text
          class="mt-6"
          style="font-size: initial !important"
         
          
          v-if="arrValidacaoEstoque.length <= 0"
        >
          <v-alert
            width="100%"
            color="#4caf50"
            style="color: white;"
          >
            <div><b><u>Termos e Condições: </u></b></div>
            <br>
            <div> - Este Kit possui produtos com disponibilidade futura, de acordo com as datas informadas acima.</div>
            <div> - Seu Pedido será enviado após esta data (maior data entre os itens).</div>
            <div> - Todos os itens serão enviados em conjunto.</div>
            <div> - O prazo de entrega inicia após a chegada dos itens no estoque.</div>
            <br>
            <v-checkbox
              color="rgb(255, 206, 0)"
              style="color: white;"
              v-model="checkboxPreVenda"
            >
              <template v-slot:label>
                <div style="color: white;">
                  Li e aceito os termos e condições.
                </div>
              </template>
            </v-checkbox>
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn
            v-if="(arrValidacaoEstoque.length <= 0 && arrValidacaoEstoque.length <= 0 && checkboxPreVenda)"
            color="primary"
            text
            @click="addMiniCart(newProduct, true)"
            style="background-color: rgb(0, 90, 100); width: 120px;"
          >
            <span style="color: white">Continuar</span>
          </v-btn>
          <v-btn
            style="width: 120px;"
            color="error"
            @click="dialogValidations.active = false"
          >
            <span>Fechar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading -->
    <v-dialog v-model="loading.active" persistent width="300">
      <v-card color="var(--standardGreen)" dark>
        <v-card-text style="padding: 27px">
          <div v-html="loading.message"></div>
          <v-progress-linear
            style="margin-top: 15px"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";
import util from "../../util/util";

Date.prototype.addDays = function (days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};


export default {
  /**
   * -- ATENÇÃO --
   * Querido(a) Programador(a)
   * Quando eu escrevi este código, apenas Deus e eu sabíamos como ele funcionava.
   * Agora, apenas Deus sabe!
   * 
   * Aumente o contador com as horas gastas tentando entender o funcionamento:
   * total_de_horas_gastas_aqui: 322
   * 
   * -- OBRIGADO --
   */
  data() {
    return {
      isCustomized: false,
      isSolar: false,
      skusPrice: null,
      solarComponents: [],
      arrayItensSolar: [],
      arrayComponents: [],
      arrayListaDtAviso: [],
      arraySummary: [],
      dataComponentesItens: [],
      totalValueSolar: null,
      btn: 0,
      produto: {
        NameComplete: null,
        AlternateIds: {
          RefId: null
        },
      },
      sla: null,
      precoFrete: null,
      loader: false,
      imagensProduto: [],
      especificacaoTecnica: null,
      garantiaFornecedor: null,
      informacoesAdicionais: null,
      capacidade: null,
      ciclo: null,
      tecnologia: null,
      voltagem: null,
      classeEnergetica: null,
      emailadicional: null,
      precoProduto: null,
      enableButton: true,
      slickOptions: {
        slidesToShow: 1,
        dots: false,
        arrows: false,
      },
      validadeDe: null,
      validadeAte: null,
      descontoSolar: 0,
      dialog: {
        active: false,
        title: "",
        message: "",
      },
      calculoPotencia: null,
      potenciaTotal: null,
      potenciaTotalModulos: null,
      fatorSobrecarga: 0,
      fatorSobrecargaCor: null,
      fatorSobrecargaMensagem: null,
      mensagemPotencia: null,
      totalModulosSuportados: 0,
      mensagemEstrutura: null,
      slaSelecionado: null,
      sku: null,
      NrProposta: null,
      CnpjCpf: null,
      nomeCliente: null,
      max: null,

      // Mensagens exibidas nos itens da calculadora
      mensagemAlertaEstoque: "Quantidade se encontra indisponível no momento!",
      mensagemAlertaEncomenda: "Item sob encomenda!",
      mensagemAlertaPreVenda: "Item em Pré-Venda!",
      mensagemBloquioEstoque: "Quantidade selecionada indisponível no momento!",

      // Arrays de controle - Alerta final
      arrValidacaoEstoque: [],
      arrAlertaEstoque: [],
      arrAlertaEncomenda: [],
      arrAlertaPreVenda: [],
      checkboxPreVenda: false,
      // Controle alerta
      dialogValidations: {
        active: false
      },
      newProduct: null,
      cep: null,
      loading:{
        active: false,
        message: null
      },
      fitrosMotobomba: null,
      headers: [
        { 
          text: 'Categoria',
          value: 'categoria',
          align: ' d-none',
          filter: value => {
            if (!this.categoriaMotobomba) return true
            return value === this.categoriaMotobomba
          },
        },
        { 
          text: 'Estagios',
          value: 'estagios',
          align: ' d-none',
          filter: value => {
            if (!this.estagiosMotobomba) return true
            return value === this.estagiosMotobomba
          },
        },
        { 
          text: 'Potencia Cv.',
          value: 'potencia_cv',
          align: ' d-none',
          filter: value => {
            if (!this.potenciaMotobomba) return true
            return value === this.potenciaMotobomba
          },
        },
      ],
      categoriaMotobomba: null,
      potenciaMotobomba: null,
      estagiosMotobomba: null,
      motobombaItens: [],
      exibeValorKit: false
    };
  },
  components: {
    Slick,
    "inner-image-zoom": InnerImageZoom,
  },
  watch: {
    arrayItensSolar() {
      let inversor = this.arrayItensSolar.filter(
        (item) => item.componentId == 1
      );

      this.exibeValorKit = inversor.length > 0 ? true : false
    }
  },
  methods: {
    verificaFiltros() {
      let itens = this.motobombaItens;
      if (this.categoriaMotobomba) {
        let itensComCategoriaSelecionada = itens.filter(i => i.categoria === this.categoriaMotobomba);
        itens = itensComCategoriaSelecionada;
      }

      if (this.potenciaMotobomba) {
        let itensComPotenciaSelecionada = itens.filter(i => i.potencia_cv === this.potenciaMotobomba);
        itens = itensComPotenciaSelecionada;
      }

      if (this.estagiosMotobomba) {
        let itensComEstagioSelecionado = itens.filter(i => i.estagios === this.estagiosMotobomba);
        itens = itensComEstagioSelecionado;
      }

      // Recupera os filtros que podem ser usados
      let categoriasPermitidas =  [...new Set(itens.map(i => i.categoria))];
      let potenciasPermitidas =  [...new Set(itens.map(i => i.potencia_cv))];
      let estagiosPermitidos =  [...new Set(itens.map(i => i.estagios))];

      this.fitrosMotobomba.categorias.forEach(cat => {
        cat.disabled = true;
      })
      this.fitrosMotobomba.categorias.forEach(cat => {
        categoriasPermitidas.forEach(cp => {
          if (cat.desc === cp) {
            cat.disabled = false;
          }
        })
      });

      this.fitrosMotobomba.potencia_cv.forEach(cat => {
        cat.disabled = true;
      })
      this.fitrosMotobomba.potencia_cv.forEach(cat => {
        potenciasPermitidas.forEach(cp => {
          if (cat.desc === cp) {
            cat.disabled = false;
          }
        })
      });

      this.fitrosMotobomba.estagios.forEach(cat => {
        cat.disabled = true;
      })
      this.fitrosMotobomba.estagios.forEach(cat => {
        estagiosPermitidos.forEach(cp => {
          if (cat.desc === cp) {
            cat.disabled = false;
          }
        })
      });
    },
    addMiniCart(produto, confirmado = null) {
      produto.isCustomized = this.isCustomized ? true : false;
      
      // Tratativa validação de estoque - Não permitir mais de um Kit com o mesmo SKU
      if (this.isCustomized) {
        let cart =
          localStorage.getItem("carrinho") != "" ||
          localStorage.getItem("carrinho") == null ||
          localStorage.getItem("carrinho") == undefined
            ? JSON.parse(localStorage.getItem("carrinho"))
            : [];
        // Verifica se possui um Kit no carrinho com o mesmo SKU
        let itemCarrinho = cart.filter((x) => x.sku == produto.Id);
        if (itemCarrinho.length > 0) {
          return alert (`\n \n Ops.. \n Não é possível incluir ao carrinho mais de um Kit com o mesmo SKU`)
        }
      }

      
      // Valida o Carrinho
      if (!util.validaItensCarrinhoSolar(produto)){
        return alert (`\n \n Ops.. \n Não é possível incluir ao carrinho itens de Revenda (Avulsos) e Kit's`)
      }
      if (!this.validaInversor()) {
        return;
      }

      // Fecha o dialogo
      this.dialogValidations.active = false;
      // Aplica tratativa apenas para Kits
      if (this.isCustomized && !confirmado) {
        // Verifica o array de controle de estoque e exibe o alerta
        if (this.arrValidacaoEstoque.length > 0 || 
            this.arrAlertaEstoque.length > 0 ||
            this.arrAlertaEncomenda.length > 0 ||
            this.arrAlertaPreVenda.length > 0) {

          // Ativa o dialogo
          this.dialogValidations.active = true;
          // Recupera produto a ser incluso na váriavel
          this.newProduct = produto;
          return;
        }
      }

      let totalItens = 0;
      let arrayPrazoEstoques = [];
      let arrayPrazoEstoquesEncomenda = [];
      this.arrayItensSolar.map(function(a) {
        if((a.validaEstoque == 'P' && a.prazoEstoque != null)) {
          arrayPrazoEstoques.push(a.prazoEstoque); 
        }
        else if (a.validaEstoque == 'E' || a.validaEstoque == 'A' && a.prazoEstoque != null){
          console.log(arrayPrazoEstoques);
          arrayPrazoEstoquesEncomenda.push(a.prazoEstoque); 
        }
        
      });
      console.log(arrayPrazoEstoques);
      console.log(arrayPrazoEstoquesEncomenda);   
      let diaTratado = null;
      if (arrayPrazoEstoquesEncomenda !== 'undefined' && arrayPrazoEstoquesEncomenda .length > 0) {
        let prazoMaiorE = (Math.max.apply(null,arrayPrazoEstoquesEncomenda));
        console.log (prazoMaiorE)
        let hoje = this.getCurrentDate();
        console.log(hoje)
        let hojeChico = new Date();
        console.log('hojeChico', hojeChico)
        let diasAdicionado = hojeChico.addDays(prazoMaiorE);
        console.log('Dias Adicionados', diasAdicionado);
        diaTratado = this.getCurrentDateComData(diasAdicionado);
        console.log('Tratado', diaTratado);
      }

      let arrayPrazoEstoquesFormatadas = []
      arrayPrazoEstoquesFormatadas.push(new Date(diaTratado));
      arrayPrazoEstoques.forEach(function(val) {
          let date_split = val.split('/');
          arrayPrazoEstoquesFormatadas.push(new Date('20'+date_split[2]+'/'+date_split[1]+'/'+date_split[0]));
      });

      console.log(arrayPrazoEstoquesFormatadas);
       
      let prazoMaior = new Date(Math.max.apply(null,arrayPrazoEstoquesFormatadas));

      let prazoMaiorNoFormatoDeText0 = this.getCurrentDateComData(prazoMaior)
      prazoMaiorNoFormatoDeText0 = `${prazoMaiorNoFormatoDeText0.split('/')[2]}/${prazoMaiorNoFormatoDeText0.split('/')[1]}/${prazoMaiorNoFormatoDeText0.split('/')[0]}`
      

      console.log(prazoMaiorNoFormatoDeText0);
      console.log(prazoMaior)

      // localStorage.setItem('carrinho', [])
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];
      let productAdd = {
        sku: produto.Id,
        nomeItem: produto.NameComplete,
        imagem: produto.ImageUrl,
        quantidade: 1,
        marca: produto.BrandName,
        valor: this.isCustomized
          ? this.totalValueSolar.toFixed(2)
          : this.precoProduto.toFixed(2),
        estoque: this.isSolar && !this.isCustomized ? produto.estoque : 100,
        isCustomized: this.isCustomized,
        isSolar: this.isSolar ? true : false,
        arrayItensSolar: this.isCustomized ? this.arrayItensSolar : null,
        prazoMaior: prazoMaior,
      };

      if (carrinho.length > 0) {
        let validarItem = carrinho.find((x) => x.sku == productAdd.sku);
        if (validarItem != undefined && validarItem != null) {
          carrinho.forEach(function (e) {
            if (e.sku == productAdd.sku) {
              if (e.quantidade < productAdd.estoque) {
                e.quantidade = e.quantidade + 1;
              }
            }
          });
        } else {
          carrinho.push(productAdd);
        }
      } else {
        carrinho.push(productAdd);
      }
      carrinho.forEach(function (e) {
        totalItens = parseFloat(totalItens) + parseFloat(e.quantidade);
      });
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      document.getElementsByClassName("header__quantity")[0].innerText =
        totalItens;
      document.getElementsByClassName("header__cart")[0].click();
    },

    openInfo(event, info) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("productTabs__tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("productTabs__tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(info).style.display = "block";
      event.currentTarget.className += " active";
    },
    
    increment(item) {
      console.log(item)
      var skuscomp = item.skus.split(',')[0];
      var estoque = (this.dataComponentesItens.find(x => x.sku == skuscomp).estoque);
      console.log(estoque)
      var increment = !item.inc || item.inc == 0 ? 1 : item.inc;
      if (item.validaEstoque == null || item.validaEstoque == "" || item.validaEstoque == undefined ){
        console.log(item.validaEstoque);
        console.log('Aqui 1')
       if (item.sug + increment <= item.max) {
        item.sug = item.sug + increment;
        console.log('Aqui 2')
      }

      } else if (item.validaEstoque == 'X' ){
        console.log(item.validaEstoque);
        if (item.sug + increment <= item.max) {
        item.sug = item.sug + increment;
        console.log('Aqui 3')
      }
      
       //this.$forceUpdate();
      // this.getTotalValue();
      } else if (item.validaEstoque == 'P' || item.validaEstoque == 'A' || item.validaEstoque == 'E' && item.prazoEstoque != null) {
        if (item.qtdEstoque > 0 )
        console.log('Aqui 4')
        estoque = estoque + item.qtdEstoque;
        console.log(estoque)
        console.log(item.qtdEstoque)
      //   if (estoque > 0){
      //   if(item.max > estoque) {
      //   item.max = estoque;
      // }
      console.log('Depois:'+item.max);
      if(item.max > estoque && item.validaEstoque == 'P'){
        item.max = estoque
        item.sug = item.sug + increment;
      }
      else if (item.sug + increment <= item.max ) {
        item.sug = item.sug + increment;
        console.log('Aqui 5')
      }
    
      }
       this.$forceUpdate();
      this.getTotalValue();

      console.log('prazoEstoque:'+item.prazoEstoque);
      console.log('validaEstoque:'+item.validaEstoque);
      console.log('qtdEstoque:'+item.qtdEstoque);
      console.log('Estoque SKU:'+estoque);
      console.log('Antes:'+item.max);
      
    },
    decrement(item) {
      var decrement = !item.inc || item.inc == 0 ? 1 : item.inc;
      if (item.sug - decrement >= item.min) {
        item.sug = item.sug - decrement;
      }
      this.$forceUpdate();
      this.getTotalValue();
    },
    removeSelected(component, selected) {
      component.itens.forEach((item) => {
        if (item.description != "NENHUM") {
          item.checkedItem = false;
          item.disabled = !item.disabled;
        }
      });

      if (!selected) {
        component.checked.checkedItem = true;
      }
      this.$forceUpdate();
      this.getTotalValue();
    },

    getCurrentDateComData(date){
      let data = new Date(date);
      let dia = data.getDate();
      let mes = data.getMonth() + 1;
      let ano = data.getFullYear();

      dia = dia.toString().length === 1 ? '0' + dia : dia;
      mes = mes.toString().length === 1 ? '0' + mes : mes;


      return `${ano}/${mes}/${dia}`;
    },

     getCurrentDate() {
      // Inicializa a primeira data a ser buscada (Dia atual)
      let data = new Date();
      let dia = data.getDate();
      let mes = data.getMonth() + 1;
      let ano = data.getFullYear();

      dia = dia.toString().length === 1 ? '0' + dia : dia;
      mes = mes.toString().length === 1 ? '0' + mes : mes;


      return `${ano}/${mes}/${dia}`;
    },

    getTotalValue() {
      let estruturasSelecionadas = [];
      var totalValue = null;
      var arrayItensSolar = [];
      var newArrayListaDtAviso = [];

      this.solarComponents.forEach((comp) => {
        if (comp.component.multiple_c == "S") {
          comp.itens.forEach((item) => {
              //console.log("1 - Vai tentar");
              //console.log(item.prazoEstoque);A
            if(item.prazoEstoque != null) {
              newArrayListaDtAviso.push(item.prazoEstoque);
            }
            if (item.checkedItem == true && item.description != "NENHUM") {
              // Captura as estruturas escolhidas
              if (comp.component.id == 6) {
                estruturasSelecionadas.push(item)
              }

              var arraySkus = item.skus.split(",");
              arraySkus.forEach((sku) => {
                this.skusPrice.forEach((skuPrice) => {
                  if (sku == skuPrice.sku) {
                    arrayItensSolar.push({
                      sku: sku,
                      componentId: comp.component.id,
                      refId: skuPrice.refid,
                      descricao: skuPrice.dsProduct,
                      vlrUnitario: skuPrice.price,
                      quantidade: item.sug ? item.sug : 0,
                      potencia: item.potencia,
                      validaEstoque: item.validaEstoque,
                      estoque: item.estoque,
                      estoqueSKU: skuPrice.estoque,
                      max: item.max,
                      prazoEstoque: item.prazoEstoque,
                      
                    });
                  }
                });
              });
            }
          });
        } else {
          if (comp.checked.description != "NENHUM") {
            var arraySkusChecked = comp.checked.skus.split(",");
            arraySkusChecked.forEach((sku) => {
              this.skusPrice.forEach((skuPrice) => {
                  //console.log("2 - Vai tentar");
                  //console.log(comp.checked.prazoEstoque);
                  //console.log(comp.checked.validaEstoque);
                if(comp.checked.prazoEstoque != null & (comp.checked.validaEstoque == 'P')) {
                  console.log("2 - Foi");
                  newArrayListaDtAviso.push(comp.checked.prazoEstoque);
                }
                if (sku == skuPrice.sku) {
                  arrayItensSolar.push({
                    sku: sku,
                    componentId: comp.component.id,
                    refId: skuPrice.refid,
                    descricao: skuPrice.dsProduct,
                    vlrUnitario: skuPrice.price,
                    quantidade: comp.checked.sug ? comp.checked.sug : 0,
                    potencia: comp.checked.potencia,
                    validaEstoque: comp.checked.validaEstoque,
                    estoque: comp.checked.estoque,
                    estoqueSKU: skuPrice.estoque,
                    prazoEstoque: comp.checked.prazoEstoque,
                    
                    
                  });
                }
              });
            });
          }
        }
      });

      // item.refId = CÓDIGO SAP do MATERIAL
      //Cabo 6mm vermelho
      let caboSolar6mmVermelho50 = arrayItensSolar.find(
        (item) => item.refId == "CAB02060050VM"
      );
      let caboSolar6mmVermelho100 = arrayItensSolar.find(
        (item) => item.refId == "CAB02060100VM"
      );
      let caboSolar6mmVermelho1000 = arrayItensSolar.find(
        (item) => item.refId == "CAB03061000VM"
      );

      //Cabo 6mm preto
      let caboSolar6mmPreto50 = arrayItensSolar.find(
        (item) => item.refId == "CAB02060050PT"
      );
      let caboSolar6mmPreto100 = arrayItensSolar.find(
        (item) => item.refId == "CAB02060100PT"
      );
      let caboSolar6mmPreto1000 = arrayItensSolar.find(
        (item) => item.refId == "CAB03061000PT"
      );

      //Cabo 4mm vermelho
      let caboSolar4mmVermelho50 = arrayItensSolar.find(
        (item) => item.refId == "CAB02040050VM"
      );
      let caboSolar4mmVermelho100 = arrayItensSolar.find(
        (item) => item.refId == "CAB02040100VM"
      );
      let caboSolar4mmVermelho1000 = arrayItensSolar.find(
        (item) => item.refId == "CAB03041000VM"
      );
      
      //Cabo 4mm preto
      let caboSolar4mmPreto50 = arrayItensSolar.find(
        (item) => item.refId == "CAB02040050PT"
      );
      let caboSolar4mmPreto100 = arrayItensSolar.find(
        (item) => item.refId == "CAB02040100PT"
      );
      let caboSolar4mmPreto1000 = arrayItensSolar.find(
        (item) => item.refId == "CAB03041000PT"
      );

      
      let comectorMc2P = arrayItensSolar.find(
        (item) => item.refId == "CON0102P"
      );
      // let comectorMc4P = arrayItensSolar.find(
      //   (item) => item.refId == "CON0104P"
      // );

      if (comectorMc2P) {
        let arrConectores = this.calculaQuantidadeConectores(
          comectorMc2P.quantidade
        );
        comectorMc2P.quantidade = arrConectores.qtdConectores2P;
        // comectorMc4P.quantidade = arrConectores.qtdConectores4P;
      }

      

      if (caboSolar4mmVermelho50) {
        let arrCabosVermelho4mm = this.calculaQuantidadeCabo(
          caboSolar4mmVermelho50.quantidade
        );
        //console.log('🟥4️⃣ caboSolar4mmVermelho50');
        //console.log('🟥4️⃣ arrCabosVermelho4mm', arrCabosVermelho4mm);
        caboSolar4mmVermelho50.quantidade = arrCabosVermelho4mm.qtdRolosCinquenta;
        caboSolar4mmVermelho100.quantidade = arrCabosVermelho4mm.qtdRolosCem;
        caboSolar4mmVermelho1000.quantidade = arrCabosVermelho4mm.qtdRolosMil;
      }

      if (caboSolar4mmPreto50) {
        let arrCabosPreto4mm = this.calculaQuantidadeCabo(
          caboSolar4mmPreto50.quantidade
        );

        //console.log('⬛4️⃣ caboSolar4mmPreto50');
        //console.log('⬛4️⃣ arrCabosPreto4mm', arrCabosPreto4mm);
        caboSolar4mmPreto50.quantidade = arrCabosPreto4mm.qtdRolosCinquenta;
        caboSolar4mmPreto100.quantidade = arrCabosPreto4mm.qtdRolosCem;
        caboSolar4mmPreto1000.quantidade = arrCabosPreto4mm.qtdRolosMil;
      }

      if (caboSolar6mmVermelho50) {
        let arrCabosVermelho6mm = this.calculaQuantidadeCabo(
          caboSolar6mmVermelho50.quantidade
          );
        
        //console.log('🟥6️⃣ caboSolar6mmVermelho50');
        //console.log('🟥6️⃣ arrCabosVermelho6mm', arrCabosVermelho6mm);
        caboSolar6mmVermelho50.quantidade = arrCabosVermelho6mm.qtdRolosCinquenta;
        caboSolar6mmVermelho100.quantidade = arrCabosVermelho6mm.qtdRolosCem;
        caboSolar6mmVermelho1000.quantidade = arrCabosVermelho6mm.qtdRolosMil;
      }

      if (caboSolar6mmPreto50) {
        let arrCabosPreto6mm = this.calculaQuantidadeCabo(
          caboSolar6mmPreto50.quantidade
          );
        
        //console.log('⬛6️⃣ caboSolar6mmPreto50');
        //console.log('⬛6️⃣ arrCabosPreto6mm', arrCabosPreto6mm);
        caboSolar6mmPreto50.quantidade = arrCabosPreto6mm.qtdRolosCinquenta;
        caboSolar6mmPreto100.quantidade = arrCabosPreto6mm.qtdRolosCem;
        caboSolar6mmPreto1000.quantidade = arrCabosPreto6mm.qtdRolosMil;
      }

      // Controle de Itens repetidos
      let arrayControle = [];
      // Percorre os itens
      arrayItensSolar.forEach((item) => {
        // Verifica se possui mais de um refId igual no array de controle
        if (!arrayControle.find((controlID) => controlID == item.refId)) {
          // Busca todos os itens com o mesmo RefId no array
          let findItens = arrayItensSolar.filter(
            (arr) => item.refId == arr.refId
          );
          let quantidade = 0;
          // Verifica se foi encontrado mais de um item
          if (findItens.length > 1) {
            // Recupera a quantidade total de cada item
            let arrayQtd = findItens.map((itemFind) => itemFind.quantidade);
            // Soma a quantidade total
            quantidade = arrayQtd.reduce(
              (accumulator, currentValue) => accumulator + currentValue
            );
            // Atualiza a quantidade total do item
            item.quantidade = quantidade;
          }
          // Insere o item no array de controle
          arrayControle.push(item.refId);
        } else {
          // Seta quantidade 0 caso o item já estiver no array
          item.quantidade = 0;
        }
      });

      // Remove os itens com quantidade 0
      let arrayItensFinal = arrayItensSolar.filter(
        (item) => item.quantidade != 0
      );

      // ##################################################################
      // Calculo de Potencia - Inversores & Módulos
      // ##################################################################
      if (this.calculoPotencia) {
        let inversores = arrayItensFinal.filter(
          (item) => item.componentId == 1
        );

        let valorTotal = 0;
        inversores.forEach((inv) => {
          if (inv.potencia) {
            valorTotal += inv.potencia * inv.quantidade;
          }
        });

        this.calculoPotencia.max = this.calculoPotencia.max ? this.calculoPotencia.max : 999999;
        if (valorTotal > this.calculoPotencia.max) {
          this.mensagemPotencia =
            "Potência de Inversores acima do limite de " +
            this.calculoPotencia.max.toFixed(2).replace(".", ",") +
            "KW";
        } else if (valorTotal < this.calculoPotencia.min) {
          this.mensagemPotencia =
            "Potência de Inversores abaixo do limite de " +
            this.calculoPotencia.min.toFixed(2).replace(".", ",") +
            "KW";
        } else {
          this.mensagemPotencia = null;
        }
        this.potenciaTotal = valorTotal.toFixed(2).replace(".", ",");

        // Calcula potência dos módulos
        let modulos = arrayItensFinal.filter(
          (item) => item.componentId == 2
        );

        let valorTotalMod = 0;
        modulos.forEach((mod) => {
          if (mod.potencia) {
            valorTotalMod += mod.potencia * mod.quantidade;
          }
        });

        this.potenciaTotalModulos = valorTotalMod.toFixed(2).replace(".", ",");

        if (valorTotalMod !== 0 && valorTotal !== 0) {
          this.fatorSobrecarga = Math.floor(parseFloat(((valorTotalMod / valorTotal) * 100).toFixed(2)))
          if (this.fatorSobrecarga < 80) {
            this.fatorSobrecargaCor = 'red'
            this.fatorSobrecargaMensagem = 'Baixo desempenho do sistema'
          } else if (this.fatorSobrecarga < 100) {
            this.fatorSobrecargaCor = 'rgb(255, 206, 0)'
            this.fatorSobrecargaMensagem = 'Sistema subdimensionado'
          } else if (this.fatorSobrecarga < 125) {
            this.fatorSobrecargaCor = 'green'
            this.fatorSobrecargaMensagem = 'Operação ideal do sistema'
          } else if (this.fatorSobrecarga < 140) {
            this.fatorSobrecargaCor = 'rgb(255, 206, 0)'
            this.fatorSobrecargaMensagem = 'Possibilidade de limitação de potência'
          } else {
            this.fatorSobrecargaCor = 'red'
            this.fatorSobrecargaMensagem = 'Maior limitação de potência'
          }
        } else {
          this.fatorSobrecarga = 0
          this.fatorSobrecargaCor = null
          this.fatorSobrecargaMensagem = null
        }
      }
      // ##################################################################


      // ##################################################################
      // Controle de Modulos - Calcula o minimo de Modulos com base
      // na capacidade total de cada Kit escolhido
      // ##################################################################
      this.totalModulosSuportados = 0;
      estruturasSelecionadas.forEach((est) => {
        if (est.potencia) {
          this.totalModulosSuportados += est.potencia * est.sug;
        }
      });

      // Filtra módulos selecionados
      let modulosSelecionados = arrayItensFinal.filter(
        (item) => item.componentId == 2
      );

      // Soma quantidades de modulos
      let totalModulos = 0;
      modulosSelecionados.forEach((mod) => {
        if (mod.potencia) {
          totalModulos += mod.quantidade;
        }
      });
      
      // Valida se a quantidade de modulos selecionado
      // é maior que a quantidade de modulos suportados
      if (totalModulos> this.totalModulosSuportados) {
        this.mensagemEstrutura = "Insuficiente para a quantidade de módulos escolhida";
      } else {
        this.mensagemEstrutura = null;
      }
      // ##################################################################


      // Realiza o calculo de valor final
      arrayItensFinal.forEach((item) => {
        totalValue += item.vlrUnitario * item.quantidade;
      });

      // Limpa arrays de controle de bloqueios
      this.arrAlertaEstoque = [];
      this.arrAlertaEncomenda = [];
      this.arrAlertaPreVenda = [];
      this.arrValidacaoEstoque = [];

      // Tratativa de Bloqueios de Estoque
      /**
       * Percorre todos os componentes e compara com o array "limpo" de produtos
       * selecionados incluindo o bloqueio em cada item com a devida validação "validaEstoque"
       * do componente pai.
       */

      this.solarComponents.forEach((comp) => {
        if (comp.component.multiple_c == "S") {
          comp.itens.forEach((item) => {
            if (item.checkedItem == true && item.description != "NENHUM") {
              item.bloqueios = [];
              var arraySkus = item.skus.split(",");
              arraySkus.forEach((sku) => {
                arrayItensFinal.forEach((aif) => {
                  if (aif.sku === sku) {
                    if (item.validaEstoque && item.validaEstoque !== null) {
                      if (aif.quantidade > aif.estoqueSKU) {
                        let newBloq = {
                          tipo: item.validaEstoque,
                          dsProduct: aif.descricao,
                          refID: aif.refid,
                          sku: aif.sku,
                          prazoEstoque: item.prazoEstoque
                        };
                        // Inclui no array de Bloqueios do item selecionado
                        item.bloqueios.push(newBloq);
                        // Inclui no array de controle de Bloqueios
                        if (item.validaEstoque === 'A' && item.prazoEstoque) {
                          this.arrAlertaEstoque.push(newBloq)
                        } else if (item.validaEstoque === 'E' && item.prazoEstoque) {
                          this.arrAlertaEncomenda.push(newBloq)
                        } else if (item.validaEstoque === 'P' && item.prazoEstoque) {
                          this.arrAlertaPreVenda.push(newBloq)
                        } else {
                          this.arrValidacaoEstoque.push(newBloq)
                        }
                      }
                    }
                  }
                });
              });
            }
          });
        } else {
          if (comp.checked.description != "NENHUM") {
            comp.checked.bloqueios = [];
            var arraySkusChecked = comp.checked.skus.split(",");
            arraySkusChecked.forEach((sku) => {
              arrayItensFinal.forEach((aif) => {
                if (aif.sku === sku) {
                  if (comp.checked.validaEstoque && comp.checked.validaEstoque !== null) {
                    if (aif.quantidade > aif.estoqueSKU) {
                      let newBloq = {
                        tipo: comp.checked.validaEstoque,
                        dsProduct: aif.descricao,
                        refID: aif.refid,
                        sku: aif.sku,
                        prazoEstoque: comp.checked.prazoEstoque,
                      };
                      // Inclui no array de Bloqueios do item selecionado
                      comp.checked.bloqueios.push(newBloq)
                      // Inclui no array de controle de Bloqueios
                      if (comp.checked.validaEstoque === 'A' && comp.checked.prazoEstoque) {
                        this.arrAlertaEstoque.push(newBloq)
                      } else if (comp.checked.validaEstoque === 'E' && comp.checked.prazoEstoque) {
                        this.arrAlertaEncomenda.push(newBloq)
                      } else if (comp.checked.validaEstoque === 'P' && comp.checked.prazoEstoque) {
                        if (comp.checked.qtdEstoque > 0){
                          aif.estoqueSKU = aif.estoqueSKU + comp.checked.qtdEstoque,
                          this.arrAlertaPreVenda.push(newBloq)

                        }
                        else {
                          this.arrAlertaPreVenda.push(newBloq)
                        }
                        
                      } else {
                        this.arrValidacaoEstoque.push(newBloq)
                      }
                    }
                  }
                }
              });
            });
          }
        }
      });
 
      this.totalValueSolar = totalValue;
      this.arrayItensSolar = arrayItensFinal;
      this.arrayListaDtAviso = newArrayListaDtAviso;

      this.renderSummary();

      // Por fim calcula o Valor do Frete
      this.calcularFrete();
    },
    renderSummary() {
      this.arraySummary = [];
      this.arrayComponents.forEach((comp) => {
        let itensComponent = this.arrayItensSolar.filter((item) => {
          return comp.id == item.componentId;
        });
        comp.itens = itensComponent;
        this.arraySummary.push(comp);
      });
    },
    calculaQuantidadeConectores(qtdConectores) {
      // let qtdConectores4P = 0;
      // if (qtdConectores >= 4) {
      //   qtdConectores4P = Math.trunc(qtdConectores / 4);
      //   qtdConectores = qtdConectores - qtdConectores4P * 4;
      // }

      let qtdConectores2P = 0;
      if (qtdConectores >= 2) {
        qtdConectores2P = Math.trunc(qtdConectores / 2);
        qtdConectores = qtdConectores - qtdConectores2P * 2;
      }

      return { qtdConectores2P};
    },
    calculaQuantidadeCabo(qtdCabo) {
      let qtdRolosMil = 0;
      if (qtdCabo >= 1000) {
        qtdRolosMil = Math.trunc(qtdCabo / 1000);
        qtdCabo = qtdCabo - qtdRolosMil * 1000;
      }

      let qtdRolosCem = 0;
      if (qtdCabo >= 100) {
        qtdRolosCem = Math.trunc(qtdCabo / 100);
        qtdCabo = qtdCabo - qtdRolosCem * 100;
      }

      let qtdRolosCinquenta = 0;
      if (qtdCabo >= 50) {
        qtdRolosCinquenta = Math.trunc(qtdCabo / 50);
        qtdCabo = qtdCabo - qtdRolosCinquenta * 50;
      }

      return { qtdRolosCinquenta, qtdRolosCem, qtdRolosMil };
    },

    validaInversor() {
      if (this.isCustomized) {
        let inversor = this.arrayItensSolar.filter(
          (item) => item.componentId == 1
        );
        if (inversor.length == 0) {
          this.dialog.title = "Ops...";
          this.dialog.message = "A seleção de Inversor é obrigatória!";
          this.dialog.active = true;
          return false;
        }

        if (this.mensagemPotencia) {
          this.dialog.title = "Ops...";
          this.dialog.message = this.mensagemPotencia;
          this.dialog.active = true;
          return false;
        }
      }
      return true;
    },
    async calcularFrete() {
      if (this.cep && this.cep !== '' && this.cep !== null) {
        this.loader = true;
        if (this.cep.length == 8) {
          let items = [];
          let saleschannel = JSON.parse(localStorage.getItem("saleChannel"));
          this.canalVendas = saleschannel;
            let _items = {
              idSku: this.sku,
              quantidade: 1,
              price: this.totalValueSolar,
            };
            items.push(_items);
          let body = {
            location: {
              zipCode: this.cep.replace("-", ""),
            },
            saleschannel: saleschannel,
            items: items,
          };
          let simularFrete = await axios({
            method: "post",
            data: body,
            url: "https://www.leverosintegra.com.br/Map/api/ShippingSimulation/V2",
          }).then((res) => {
            return res.data;
          });
          this.loader = false;
          let sla = [];
          let valorFrete = [];
          if (simularFrete.freightSimulated.length > 0) {
            simularFrete.freightSimulated[0].slaResponseFreightSimulated.forEach(
              function (frete) {
                let pushSla = true;
                let _frete = {
                  preco: (frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice),
                  sla: frete.totalTime,
                  tipo: frete.slaType,
                  descricao: frete.slaTypeName,
                textoFrete: frete.slaTypeName !== 'Agendada' ? `${frete.slaType} - R$ ${(frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice)
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")} (Entrega em até ${
                  frete.totalTime
                } dias úteis)` : `${frete.slaType} - R$ ${(frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice)
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")} (Verificar datas disponíveis na tela de finalização)`,
                };

                // if (_frete.tipo == "Agendada") {
                //   _frete.textoFrete = `${_frete.tipo} - R$ ${(frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice)
                //     .toFixed(2)
                //     .toString()
                //     .replace(".", ",")} (Entrega a combinar)`;
                // }
                if (sla.length == 0) {
                  pushSla = true;
                } else if (sla.find((x) => x.tipo == frete.slaType) != null) {
                  pushSla = false;
                }
                if (pushSla) {
                  sla.push(_frete);
                }
              }
            );
          }
          this.sla = sla;
          this.precoFrete = valorFrete;
          this.recuperarInfosProdutos();
        }
      }
    },
    selecionaSLA(sla) {
      this.slaSelecionado = sla;
    },

    async sendBudget() {
      if (!this.validaInversor()) {
        return;
      }
      if (!this.slaSelecionado){
        this.dialog.title = "Ops...";
        this.dialog.message = "Erro ao enviar e-mail, escolha de frete é obrigatória!";
        this.dialog.active = true;
        return;
      }
      
      var solarEmail = document.getElementById("summaryEmail");
      var user = JSON.parse(localStorage.getItem("login"));
      var emailadicional = document.getElementById("emailAdicional").value;

      if (user) {
        if (emailadicional == "") {
          emailadicional = user.email;
        }
        let assuntoEmail = "Orçamento Solar "
        assuntoEmail += this.nomeCliente ? ' - ' + this.nomeCliente : '';
        assuntoEmail += this.NrProposta ?' - ' + this.NrProposta: '';
        await axios({
          method: "post",
          url: "https://www.leverosintegra.com.br/MAP/api/email",
          data: {
            to: [user.email],
            cc: [emailadicional],
            subject:
              assuntoEmail + " - "+
              this.produto.NameComplete +
              " " +
              this.$options.filters.toCurrency(this.totalValueSolar),
            bodyEmail: solarEmail.outerHTML,
          },
        })
          .then((res) => {
            if (res.status == 200) {
              this.dialog.title = "Orçamento gerado!";
              this.dialog.message =
                "Olá parceiro! <br> Obrigado por cotar com a Leveros Solar! Enviamos o orçamento para o seu e-mail.";
            } else {
              this.dialog.title = "Ops...";
              this.dialog.message = "Erro ao enviar e-mail, tente novamente!";
            }

            this.dialog.active = true;
          })
          .catch((err) => {
            console.log(err);
            this.dialog.title = "Ops...";
            this.dialog.message = "Erro ao enviar e-mail, tente novamente!";
            this.dialog.active = true;
          });
      } else {
        this.dialog.title = "Ops...";
        this.dialog.message =
          "É necessário estar logado para gerar o orçamento!";
        this.dialog.active = true;
      }
    },
  },

  async created() {
    this.loading.message = "Buscando dados, aguarde...";
    this.loading.active = true;
    const saleChannel = localStorage.getItem("saleChannel")
    var url = new URL(window.location.href);
    this.sku = url.searchParams.get("sku");
    var sku = url.searchParams.get("sku");
    // Recebo o parâmetro se o produto é Solar / Customizavel
    var isCustomized = url.searchParams.get("isCustomized");
    var isSolar = url.searchParams.get("isSolar");
    // Atualiza a tela
    this.isCustomized = isCustomized ? true : false;
    this.isSolar = isSolar ? true : false;
    if (this.isCustomized) {
      // Busca configuráveis
      await axios({
        method: "get",
        url: `https://www.leverosintegra.com.br/MAP/api/solar?sku=${sku}&saleChannel=${saleChannel}`,
        //url: `http://localhost:54015//api/solar?sku=${sku}&saleChannel=${saleChannel}`,
      })
        .then((res) => {
          if (res && res.status == 200) {
            // Recupera os dados
            var data = res.data;
            this.arrayComponents = data.components;
            var componentsItems = data.componentsItems;
            this.dataComponentesItens = data.skus;
            this.skusPrice = data.skus;
            this.calculoPotencia = data.potencia;
            this.fitrosMotobomba = data.filtrosMotobomba;
            this.max = data.max;      
            if (this.fitrosMotobomba) {

              if (this.fitrosMotobomba.categorias === null) {
                this.fitrosMotobomba.categorias = [];
              }

              if (this.fitrosMotobomba.potencia_cv === null) {
                this.fitrosMotobomba.potencia_cv = [];
              }

              if (this.fitrosMotobomba.estagios === null) {
                this.fitrosMotobomba.estagios = [];
              }
              
              let categorias = [];
              this.fitrosMotobomba.categorias.forEach(el => {
                categorias.push({
                  desc: el,
                  disabled: false
                })
              });
              this.fitrosMotobomba.categorias = categorias;

              let potencias = [];
              this.fitrosMotobomba.potencia_cv.forEach(el => {
                 potencias.push({
                  desc: el,
                  disabled: false
                })
              });
              this.fitrosMotobomba.potencia_cv = potencias;

              let estagios = [];
              this.fitrosMotobomba.estagios.forEach(el => {
                 estagios.push({
                  desc: el,
                  disabled: false
                })
              });
              this.fitrosMotobomba.estagios = estagios;
              
              this.motobombaItens = componentsItems.filter(ci => ci.idComponent === 10 && ci.description !== "NENHUM");
            }

            // Tratativa para Kits padrões (Que não possuem min e max na Base)
            if (!this.calculoPotencia) {
              this.calculoPotencia = {
                min: 0,
                max: 999999
              }
            }

            // Recupera o desconto Solar
            this.descontoSolar = data.descontoSolar;

            this.arrayComponents.forEach((component) => {
              var itens = [];
              var checked = null;

              componentsItems.forEach((item) => {
                if (component.id == item.idComponent) {
                  item.checkedItem =
                    item.checkedItem == "checked" ? true : false;
                  itens.push(item);
                  if (item && item.checkedItem && item.checkedItem == true) {
                    checked = item;
                  }
                }
              });
              this.solarComponents.push({
                component,
                itens,
                checked: checked,
              });
            });

            // Tratativa para componentes com sugestao 'NENHUM'
            this.solarComponents.forEach((arrComp) => {
              if (arrComp.component.multiple_c == "S") {
                if (arrComp && arrComp.checked && arrComp.checked.description == "NENHUM") {
                  arrComp.itens.forEach((item) => {
                    if (item.description != "NENHUM") {
                      item.disabled = true;
                    }
                  });
                }
              }
            });

            this.getTotalValue();
            this.loading.active = false;
          }
        })
        .catch((err) => {
          this.loading.active = false;
          if (err.response && err.response.status == 401) {
            alert(`Acesso não autorizado, erro: ${err}`);''
          } else {
            alert(`Ops...\nOcorreu algum erro de cadastro =/ \n: ${err}`);
          }
        });
    }

    let precoProduto = JSON.parse(localStorage.getItem("precoDetails"));
    if (precoProduto.sku != sku) {
      this.enableButton = false;
    }

    let qtdEstoque = 0;
    // Busca a quantidade de estoque de itens avulsos
    if (this.isSolar && !this.isCustomized) {
      let dados = JSON.parse(localStorage.getItem("login"));
      if (dados != undefined) {
        this.token = dados.token;
      } else {
        this.token = "";
      }
  
      // Busca dados do produto no LVI
      axios({
        method: "post",
        data: {
          TabelaPreco: saleChannel,
          isSaleSolar: isSolar,
          Descricao: sku
        },
        url: `https://www.leverosintegra.com.br/map/Api/ProdutoLista?token=${this.token}`,
      }).then(res => {
        if (res.data && res.data.lcardapio[0]) {
          qtdEstoque = res.data.lcardapio[0]._Disponivel;
        }
      })
    }

    this.precoProduto = precoProduto.preco;
    const response = await axios({
      method: "get",
      url: `https://www.leverosintegra.com.br/map/api/GetItemData/${sku}`,
    });
    if (response.data != null) {
      if (response.data.ProductSpecifications != null) {
        if (response.data.ProductSpecifications.length > 0) {
          let especificacaoTecnica = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Especificação Técnica"
          );
          let garantiaFornecedor = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Garantia do fornecedor"
          );
          let informacoesAdicionais = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Informações Adicionais"
          );
          let capacidade = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Capacidade BTUs"
          );
          let ciclo = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Ciclo"
          );
          let tecnologia = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Tecnologia"
          );
          let voltagem = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Voltagem"
          );
          let classeEnergetica = response.data.ProductSpecifications.find(
            (x) => x.FieldName == "Classificação Energética"
          );
          if (especificacaoTecnica != null) {
            this.especificacaoTecnica = especificacaoTecnica.FieldValues[0];
          }
          if (garantiaFornecedor != null) {
            this.garantiaFornecedor = garantiaFornecedor.FieldValues[0];
          }
          if (informacoesAdicionais != null) {
            this.informacoesAdicionais = informacoesAdicionais.FieldValues[0];
          }
          if (capacidade != null) {
            this.capacidade = capacidade.FieldValues[0];
          }
          if (ciclo != null) {
            this.ciclo = ciclo.FieldValues[0];
          }
          if (tecnologia != null) {
            this.tecnologia = tecnologia.FieldValues[0];
          }
          if (voltagem != null) {
            this.voltagem = voltagem.FieldValues[0];
          }
          if (classeEnergetica != null) {
            this.classeEnergetica = classeEnergetica.FieldValues[0];
          }
        }
      }

      this.produto = response.data;
      this.produto.estoque = qtdEstoque;

      axios.get("https://pricing-api.leverosservicos.com.br/price/solar").then((res) => {
        let refId = this.produto.AlternateIdValues[0];
        let datas = res.data.find((i) => i.productId == refId);

        // Recupera a data de preço vigente
        this.validadeAte = datas != undefined ? datas.finalDate : null;
        this.validadeDe = datas != undefined ? datas.initialDate : null;
      });
    }

    this.imagensProduto = response.data.Images;
    this.loading.active = false;
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 35%;

  i {
    color: var(--customBlue);
    margin-top: 30px;
  }

  span:nth-child(2) {
    padding-top: 10px;
    font-size: 0.95rem;
  }
}
#Descricao {
  display: block;
}
.productDetails {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 90%;
  margin: 0 auto;
  padding: 70px 0 50px 0;

  @media (max-width: 800px) {
    flex-direction: column;
    padding: 40px 0 50px 0;
  }

  @media (min-width: 1920px) {
    max-width: 70%;
  }
}

.v-data-table__wrapper {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}

.productNameMobile {
  display: block;
  padding-bottom: 25px;

  @media (min-width: 801px) {
    display: none;
  }

  &__title {
    color: var(--customGray-500);
    font-size: 1.3rem;
  }
}

.productImages {
  width: 45%;
  border: 1px solid var(--customGray-100);
  border-radius: 5px;
  padding: 10px 0;

  img {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 800px) {
    width: 100%;
    position: unset !important;
  }

  ::v-deep button::before {
    font-size: 0.938rem;
    color: var(--standardGreen);
  }

  ::v-deep .slick-dots li.slick-active button:before {
    color: var(--standardGreen);
  }

  &__quantityImages {
    text-align: center;
    margin: 0 auto;
    padding: 10px 0;
    font-size: 0.95rem;
    background: var(--customGray-200);
    color: var(--customWhite);
    border-radius: 5px;
    width: 15%;
  }
}

.productInfos {
  width: 45%;

  @media (max-width: 800px) {
    width: 100%;
  }

  &__nameModel {
    padding-bottom: 35px;

    h1 {
      font-size: 1.25rem;
      color: var(--customGray-500);
      padding-bottom: 15px;
      display: none;

      @media (min-width: 800px) {
        display: block;
      }
    }

    p {
      color: var(--customGray-500);
      line-height: 1.4;
      font-size: 0.95rem;
      display: none;

      @media (min-width: 1023px) {
        display: block;
      }
    }
  }

  &__icons {
    margin-bottom: 30px;
    display: flex;

    @media (max-width: 440px) {
      flex-wrap: wrap;
      justify-content: center;
    }

    .icons {
      &__group {
        display: flex;
        align-items: center;
        font-size: 0.95rem;
        margin-right: 15px;

        p {
          padding-left: 10px;
          font-weight: bold;
          color: var(--customGray-500);
        }

        .classeA {
          &::before {
            content: url("https://multiar.vteximg.com.br/arquivos/ico-qualidade-energetica2.png");
            vertical-align: middle;
          }

          &:after {
            background: green;
            margin-left: 5px;
            padding: 1px 3px;
            color: var(--customWhite);
            content: attr(data);
          }
        }

        .classeB {
          &::before {
            content: url("https://multiar.vteximg.com.br/arquivos/ico-qualidade-energetica2.png");
            vertical-align: middle;
          }

          &:after {
            background: #bfd631;
            color: var(--customWhite);
            margin-left: 5px;
            padding: 1px 3px;
            content: attr(data);
          }
        }

        .classeC {
          &::before {
            content: url("https://multiar.vteximg.com.br/arquivos/ico-qualidade-energetica2.png");
            vertical-align: middle;
          }

          &:after {
            background: #a6bd11;
            color: var(--customWhite);
            margin-left: 5px;
            padding: 1px 3px;
            content: attr(data);
          }
        }
      }
    }
  }

  &__priceCart {
    h2 {
      color: var(--standardGreen);
      font-size: 1.6rem;
    }

    span {
      color: var(--standardGreen);
      font-size: 1rem;
    }

    &--text {
      color: var(--customGray-500);
      line-height: 1.9;
      font-size: 1rem;

      span {
        font: 700 1rem "Soleto", sans-serif;
        color: var(--standardGreen);
      }
    }
  }

  &__cart {
    margin-top: 25px;
    background: var(--standardGreen);
    padding: 10px;
    border-radius: 5px;
    width: 70%;
    outline: none;
    color: var(--customWhite);
    text-decoration: none;
    font: 700 1rem "Soleto", sans-serif;

    i {
      font-size: 1.25rem;
      padding-right: 10px;
    }

    @media (max-width: 440px) {
      width: 100%;
    }

    @media (min-width: 1920px) {
      width: 50%;
    }
  }

  &__freigth {
    padding-top: 25px;

    @media (max-width: 1022px) {
      padding-top: 30px;
    }

    p {
      color: var(--customGray-500);
      font: 700 1rem "Soleto", sans-serif;
      padding-bottom: 10px;

      &:last-child {
        font-size: 0.625rem;
        text-decoration: none;
        position: relative;
        left: 102px;
        padding-top: 5px;

        @media (max-width: 440px) {
          position: initial;
          left: 0;
        }

        a {
          color: var(--customGray-500);
          font-weight: 400;
        }
      }
    }

    input {
      border: 1px solid var(--customGray-200);
      border-radius: 5px;
      padding: 8px;
      font-size: 0.95rem;
      outline: none;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    button {
      outline: none;
      position: relative;
      left: -30px;
    }
  }

  &__buttonBuy {
    background: rgba(255, 255, 255, 0.959);
    border-top: 1px solid var(--customGray-200);
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 15px;

    @media (min-width: 441px) {
      display: none;
    }

    .buttonBuy {
      &__infos {
        display: flex;
        flex-direction: column;
        width: 45%;

        span {
          color: var(--customGray-500);
        }
      }
    }

    button {
      width: 50%;
      background: var(--standardGreen);
      border-radius: 10px;
      padding: 10px;
      color: var(--customWhite);
      text-transform: uppercase;

      i {
        padding-right: 10px;
      }
    }
  }
}
.freigth {
  &__options {
    margin-top: 20px;
  }

  &__items {
    width: 70%;

    @media (max-width: 440px) {
      width: 100%;
    }

    p {
      padding: 10px 5px;
      font-size: 0.875rem;
      color: var(--customGray-500);

      &:hover {
        background: var(--customGray-100);
        border-radius: 5px;
      }

      span {
        color: var(--standardGreen);
        font: 700 0.95rem "Soleto", sans-serif;
      }
    }
  }
}

.customKit {
  height: 100%;
  position: sticky;
  top: 30px;
}

.summary {
  box-shadow: 0 0 1em #ffcc0075;
  padding: 1.3em;
  margin: 4.8em;
  margin-top: 0 !important;
  border-radius: 16px;

  h2,
  p,
  h4,
  .summary_list {
    color: #707070;
  }
}

input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  width: 20px;
  height: 20px;
  padding: 4px;
  background-clip: content-box;
  border: 2px solid #bbbbbb;
  background-color: #e7e6e7;
  border-radius: 50%;
  vertical-align: top;
}

input[type="radio"]:checked {
  background-color: #005a64 !important;
}

.buyTogether {
  max-width: 85%;
  margin: 0 auto;
  padding-bottom: 50px;

  &__title {
    color: var(--standardGreen);
    font-size: 0.95rem;
    border-bottom: 1px solid var(--customGray-200);
    padding: 10px 0;
  }

  &__suggestion {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    padding: 30px 0;

    @media (max-width: 440px) {
      flex-direction: column;
    }

    &--product,
    &--service {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: var(--customGray-500);

      @media (max-width: 440px) {
        width: 100%;
      }

      &--name {
        p {
          font-size: 0.95rem;
          padding: 10px 0;
          text-align: center;

          a {
            text-decoration: none;
            color: var(--customGray-500);
          }
        }
      }

      &--price {
        p {
          padding: 10px 0;
          font: 700 1.125rem "Soleto", sans-serif;

          span {
            font-size: 0.813rem;
          }
        }
      }
    }

    &--plus,
    &--igual {
      font-size: 2.188rem;
      color: var(--standardGreen);
      border-radius: 100%;
      width: 5%;
      padding: 0 20px;
    }

    &--buy {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      line-height: 1.7;
      color: var(--customGray-500);
      width: 30%;

      @media (max-width: 440px) {
        width: 100%;
        padding: 30px 0 0 0;
      }

      p:nth-child(2) {
        color: var(--standardGreen);
        font: 700 1.375rem "Soleto", sans-serif;

        span {
          font-size: 0.813rem;
        }
      }

      button {
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 7px;
        margin-top: 10px;
        font-weight: bold;
        width: 100%;
      }
    }
  }
}

.productTabs {
  overflow: hidden;
  width: 85.5%;
  margin: 0 auto;
  border-radius: 5px 5px 0 0;
  border: 1px solid var(--customGray-100);
  background: var(--customGray-100);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media (max-width: 440px) {
    width: 100%;
    border-radius: 0;
    flex-direction: column;
  }

  button {
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    font: 700 0.95rem "Soleto", sans-serif;
    color: var(--customGray-800);
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;

    &:after {
      content: "+";
      font-size: 1.4rem;
    }

    &:hover {
      background-color: #cccccc;
    }

    &.active {
      background-color: #cccccc;
      color: var(--customGray-800);
    }
  }

  &__tabcontent {
    display: none;
    padding: 6px 12px;
    background: var(--customWhite);
    border-top: none;

    @media (min-width: 1920px) {
      max-width: 65.5%;
    }
    @media (max-width: 440px) {
      width: 100%;
    }

    ::v-deep h1 {
      color: var(--standardGreen);
      text-align: center;
      font-size: 1.5rem;
      padding: 30px 0 25px 0;

      @media (max-width: 440px) {
        text-align: left;
      }
    }

    ::v-deep p {
      color: var(--customGray-500);
      line-height: 1.5;
      padding: 10px 0;
      font-size: 1rem;
    }

    ::v-deep h2 {
      color: var(--standardGreen);
      padding: 15px 0;
      font-size: 1.063rem;
    }

    ::v-deep h3 {
      color: var(--standardGreen);
      font-size: 1rem;
      padding: 15px 0;
    }

    ::v-deep a {
      color: var(--standardGreen);
      font-weight: bold;
    }

    ::v-deep ul,
    ol {
      padding-left: 40px;

      li {
        color: var(--customGray-500);
        line-height: 1.7;
        padding: 5px 0;
        font-size: 1rem;
      }
    }

    ::v-deep b {
      font: 700 1rem "Soleto", sans-serif;
    }
  }
}

#Informacoes {
  > :not(br) {
    width: 50%;
    display: inline-block;
    padding: 5px 0;

    @media (max-width: 440px) {
      width: 100%;
    }
  }
}

.form-groups {
  margin-top: 25px;
  .label {
    margin-right: 5px;
    font: 700 0.95rem "Soleto", sans-serif;
  }
  .input {
    width: 60%;
    padding: 6px 15px;
    border: 1px solid #a1a1a1;
    border-radius: 5px;
    outline: none;
    text-transform: uppercase;
    font-size: 0.6rem;
  }
}

.loaderTeste {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  i {
    color: #4cdddd;
    margin-top: 30px;
  }

  span:nth-child(2) {
    padding-top: 10px;
    font-size: 0.75rem;
  }
}

.v-tooltip__content {
  opacity: 1!important;
  padding: 10px;
  max-width: 550px;
  min-width: 550px;
}

.imgCenter {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.cardAlert {
  &--red {
    border-radius: 10px !important;
    border-color: red;
  }
  &--customYellow {
    border-radius: 10px !important;
    border-color: #fb8c00;
  }
  &--customBlue {
    border-radius: 10px !important;
    border-color: #2196f3;
  }
  &--customGreen {
    border-radius: 10px !important;
    border-color: #4caf50;
  }
}
.minicart {
  visibility: hidden;
  display: block;
  position: fixed;
  right: 0;
  top: 0;
  background: var(--customWhite);
  width: 100%;
  height: 100%;
  z-index: 9999999;
  overflow-y: auto;
  box-shadow: 0 4px 20px var(--customBlack);

  @media (min-width: 769px) {
    width: 35%;
  }

  &--active {
    width: 100% !important;
    z-index: 9999999 !important;
    visibility: visible !important;

    @media (min-width: 601px) {
      visibility: visible !important;
      width: 35% !important;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid var(--customGray-100);

    h3 {
      color: var(--customDarkGreen);
    }

    i {
      font-size: 1.438rem;
      color: var(--customBlue);
      cursor: pointer;
    }
  }

  &__products {
    width: 100%;
    padding: 0 15px;
    height: calc(100% - 470px);
    overflow: auto;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 20px 0 0 0;
  }

  &__details {
    line-height: 1.7;
    width: 100%;

    p {
      font-size: 0.95rem;
      color: var(--customGray-500);
      padding: 0 30px 0 5px;
      width: 100%;

      &:nth-child(2) {
        color: var(--customDarkGreen);
        font: 700 0.975rem "Soleto", sans-serif;
      }
    }

    button {
      background: var(--standardGreen);
      color: var(--customWhite);
      width: 30px;
      height: 20px;
      margin: 7px;
      border-radius: 5px;
      outline: none;
      font: 700 0.95rem "Soleto", sans-serif;
    }

    span {
      color: var(--customDarkGreen);
      padding: 0 8px;
      font: 700 0.95rem "Soleto", sans-serif;
    }
  }

  &__iconTrash {
    position: relative;

    a i {
      font-size: 1.25rem;
      color: var(--customBlue);
    }
  }

  &__title {
    border-bottom: 1px solid var(--customGray-100);

    h3 {
      font-size: 1rem;
      color: var(--customDarkGreen);
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      padding: 10px 0;
    }
  }

  &__calculate {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  &__input {
    border: 1px solid var(--customGray-200);
    border-radius: 5px;
    padding: 7px;
    margin-top: 10px;
    outline: none;
    font-size: 0.95rem;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__buttonSearch {
    position: relative;
    left: 65px;
    top: -26px;
    outline: none;
  }

  &__toKnowCEP {
    position: relative;
    top: -18px;
    left: 45px;
    text-decoration: none;

    a {
      color: var(--customGray-500);
      font-size: 0.7rem;
    }
  }

  &__options {
    padding: 10px 30px;
  }

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    i {
      color: var(--customBlue);
    }

    span:nth-child(2) {
      color: var(--customGray-800);
      font-size: 0.85rem;
      padding-top: 10px;
    }
  }

  &__totals {
    border-top: 1px solid var(--customGray-100);
    padding: 10px 0 25px 0;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 30px;
      font-size: 0.95rem;
    }

    li span {
      color: var(--customGray-500);
      font-size: 0.95rem;
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;

    a {
      text-decoration: none;
    }

    &--cart {
      border: 1px solid var(--customDarkGreen);
      padding: 7px;
      border-radius: 5px;
      color: var(--customDarkGreen);
      font: 700 0.95rem "Soleto", sans-serif;
      outline: none;

      &:hover {
        color: var(--standardGreen);
      }
    }

    &--buy {
      background: var(--standardGreen);
      color: var(--customWhite);
      padding: 7px;
      border-radius: 5px;
      margin-left: 20px;
      font: 700 0.95rem "Soleto", sans-serif;
      outline: none;
    }
  }
}
</style>